import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './WMSModule.css';
import WarehouseMap from './components/WarehouseMap';
import { WarehousePosition } from './helpers/warehouseMap';

// â”€â”€â”€ Types â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
type Tab = 'recebimento' | 'bolsao' | 'armazenagem' | 'distribuicao' | 'movimentacoes';

interface ItemBolsao {
  id: number;
  recebimento_id: number;
  numero_nf: string;
  fornecedor: string;
  produto_codigo: string;
  descricao_item: string;
  unidade: string;
  quantidade_recebida: number;
  quantidade_esperada: number;
  status: string;
  endereco_destino: string;
  data_chegada: string;
  responsavel: string;
  prioridade?: 'alta' | 'media' | 'baixa';
  volume_m3?: number;
  peso_kg?: number;
}

interface Recebimento {
  id: number;
  numero_nf: string;
  fornecedor: string;
  transportadora: string;
  motorista: string;
  placa_veiculo: string;
  data_chegada: string;
  data_prevista: string;
  status: 'pendente' | 'conferindo' | 'recebido' | 'divergencia' | 'recusado';
  responsavel: string;
  doca: string;
  peso_total_kg: number;
  total_itens: number;
  qtd_esperada: number;
  qtd_recebida: number;
  observacoes: string;
  enviado_bolsao?: number;
  data_envio_bolsao?: string;
}

interface RecebimentoItemForm {
  descricao_item: string;
  unidade: string;
  quantidade: string;
}

interface Distribuicao {
  id: number;
  numero_pedido: string;
  cliente: string;
  destino: string;
  transportadora: string;
  motorista: string;
  placa_veiculo: string;
  data_programada: string;
  data_saida: string;
  criado_em?: string;
  status: 'programado' | 'separando' | 'conferindo' | 'expedido' | 'entregue' | 'cancelado';
  responsavel: string;
  numero_nf_saida: string;
  total_itens: number;
  qtd_total: number;
  itens_coletados?: number;
  itens_pendentes?: number;
  observacoes: string;
}

interface OndaItem {
  id: number;
  distribuicao_id: number;
  produto_id: number | null;
  descricao_item: string;
  unidade: string;
  quantidade_solicitada: number;
  quantidade_separada: number;
  status: 'pendente' | 'separado' | 'divergencia';
  endereco_origem: string | null;
  produto_codigo?: string;
  produto_descricao?: string;
  observacoes?: string;
}

interface Endereco {
  id: number;
  rua: string;
  bloco: string;
  nivel: string;
  posicao: string;
  codigo: string;
  tipo: string;
  capacidade_kg: number;
  status: 'livre' | 'ocupado' | 'bloqueado';
  produto_id: number | null;
  produto_codigo: string;
  produto_descricao: string;
  quantidade: number;
  // Linked recebimento info
  item_id?: number | null;
  item_descricao?: string | null;
  item_quantidade?: number | null;
  rec_numero_nf?: string | null;
  rec_fornecedor?: string | null;
  rec_data_chegada?: string | null;
}

interface Produto {
  id: number;
  codigo: string;
  descricao: string;
  categoria: string;
  unidade: string;
  estoque: number;
  estoqueMinimo: number;
  localizacao: string;
  status: string;
}

interface Movimentacao {
  id: string;
  tipo: string;
  evento?: string;
  documento?: string | null;
  empresa?: string | null;
  produtoCodigo: string;
  produtoDescricao: string;
  quantidade: number;
  origem: string;
  destino: string;
  endereco?: string | null;
  responsavel: string;
  entreguePor?: string | null;
  expedidoPor?: string | null;
  dataEntrada?: string | null;
  dataArmazenagem?: string | null;
  dataSaida?: string | null;
  data: string;
  observacoes: string;
}

interface RuaInfo {
  rua: string;
  bloco: string;
  total: number;
  livres: number;
  ocupados: number;
  bloqueados: number;
  tipo: string;
  capacidade_kg: number;
  max_nivel: number;
  max_posicao: number;
}

// â”€â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const formatDate = (d: string) => {
  if (!d) return '-';
  return new Date(d).toLocaleDateString('pt-BR');
};

const formatDateTime = (d: string) => {
  if (!d) return '-';
  const dt = new Date(d);
  return dt.toLocaleDateString('pt-BR') + ' ' + dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

const STATUS_REC: Record<string, { label: string; cls: string }> = {
  pendente:    { label: 'Pendente',    cls: 'badge-orange' },
  conferindo:  { label: 'Conferindo',  cls: 'badge-blue' },
  recebido:    { label: 'Recebido',    cls: 'badge-green' },
  divergencia: { label: 'Divergência', cls: 'badge-red' },
  recusado:    { label: 'Recusado',    cls: 'badge-gray' },
  expedido:    { label: 'Expedido',    cls: 'badge-teal' },
};

const STATUS_REC_OPCOES: Array<'pendente' | 'recebido' | 'divergencia' | 'recusado'> = ['pendente', 'recebido', 'divergencia', 'recusado'];

const STATUS_DIST: Record<string, { label: string; cls: string }> = {
  programado:  { label: 'Programado',  cls: 'badge-orange' },
  separando:   { label: 'Separando',   cls: 'badge-blue' },
  conferindo:  { label: 'Conferindo',  cls: 'badge-purple' },
  expedido:    { label: 'Expedido',    cls: 'badge-teal' },
  entregue:    { label: 'Entregue',    cls: 'badge-green' },
  cancelado:   { label: 'Cancelado',   cls: 'badge-red' },
};

// â”€â”€â”€ Component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const WMSModule: React.FC = () => {
  const [tab, setTab] = useState<Tab>('recebimento');
  const [loading, setLoading] = useState(false);
  const getRecFormInitialState = () => ({
    numero_nf: '', fornecedor: '', transportadora: '', motorista: '',
    placa_veiculo: '', data_chegada: '', data_prevista: '', doca: '',
    peso_total_kg: '', responsavel: '', observacoes: '', status: 'recebido'
  });
  const getRecItemInitialState = (): RecebimentoItemForm => ({ descricao_item: '', unidade: 'UN', quantidade: '1' });

  // Recebimento
  const [recebimentos, setRecebimentos] = useState<Recebimento[]>([]);
  const [showRecModal, setShowRecModal] = useState(false);
  const [editingRecId, setEditingRecId] = useState<number | null>(null);
  const [recFiltroStatus, setRecFiltroStatus] = useState('');
  const [recFormData, setRecFormData] = useState(getRecFormInitialState());
  const [recItensForm, setRecItensForm] = useState<RecebimentoItemForm[]>([getRecItemInitialState()]);

  // Armazenagem
  const [enderecos, setEnderecos] = useState<Endereco[]>([]);
  const [produtos, setProdutos] = useState<Produto[]>([]);
  const [filtroRua, setFiltroRua] = useState('');
  const [filtroStatusEnd, setFiltroStatusEnd] = useState('');
  const [selectedPosicaoArmazem, setSelectedPosicaoArmazem] = useState<WarehousePosition | null>(null);
  const [buscarRuaSidebar, setBuscarRuaSidebar] = useState('');

  // Ruas CRUD
  const [showRuasModal, setShowRuasModal] = useState(false);
  const [ruasList, setRuasList] = useState<RuaInfo[]>([]);
  const [ruasLoading, setRuasLoading] = useState(false);
  const [showRuaForm, setShowRuaForm] = useState(false);
  const [ruaFormMode, setRuaFormMode] = useState<'create' | 'edit'>('create');
  const [ruaFormData, setRuaFormData] = useState({
    rua: '', bloco: '', num_niveis: '3', num_posicoes: '10',
    tipo: 'padrao', capacidade_kg: '800'
  });
  const [ruaEditKey, setRuaEditKey] = useState<{ rua: string; bloco: string } | null>(null);

  // Distribuição
  const [distribuicoes, setDistribuicoes] = useState<Distribuicao[]>([]);
  const [showDistModal, setShowDistModal] = useState(false);
  const [distFiltroStatus, setDistFiltroStatus] = useState('');
  const [distFormData, setDistFormData] = useState({
    numero_pedido: '', cliente: '', destino: '', transportadora: '',
    motorista: '', placa_veiculo: '', data_programada: '',
    responsavel: '', observacoes: '', status: 'programado'
  });
  const [distNfBusca, setDistNfBusca] = useState('');
  const [distNfData, setDistNfData] = useState<{ itens: any[]; fornecedor?: string; [key: string]: any } | null>(null);
  const [distNfLoading, setDistNfLoading] = useState(false);

  // Picking (Separação)
  const [selectedOnda, setSelectedOnda] = useState<Distribuicao | null>(null);
  const [ondaItems, setOndaItems] = useState<OndaItem[]>([]);
  const [selectedOndaItem, setSelectedOndaItem] = useState<OndaItem | null>(null);
  const [loadingOndaItems, setLoadingOndaItems] = useState(false);

  // Bolsão
  const [itensBolsao, setItensBolsao] = useState<ItemBolsao[]>([]);
  const [bolsaoFiltroBusca, setBolsaoFiltroBusca] = useState('');
  const [bolsaoFiltroStatus, setBolsaoFiltroStatus] = useState('');
  const [bolsaoFiltroFornecedor, setBolsaoFiltroFornecedor] = useState('');
  const [bolsaoFiltroPrioridade, setBolsaoFiltroPrioridade] = useState('');
  const [bolsaoShowFiltros, setBolsaoShowFiltros] = useState(false);
  const [bolsaoSelecionados, setBolsaoSelecionados] = useState<Set<string>>(new Set());
  const [bolsaoPagina, setBolsaoPagina] = useState(1);
  const [bolsaoItensPorPagina, setBolsaoItensPorPagina] = useState(10);
  const [bolsaoUltimaAtualizacao, setBolsaoUltimaAtualizacao] = useState<Date | null>(null);
  const [showBolsaoModal, setShowBolsaoModal] = useState(false);
  const [bolsaoItemSelecionado, setBolsaoItemSelecionado] = useState<ItemBolsao | null>(null);
  const [bolsaoEnderecoIdSelecionado, setBolsaoEnderecoIdSelecionado] = useState('');
  const [bolsaoQuantidadeEnderecar, setBolsaoQuantidadeEnderecar] = useState('');
  const [bolsaoEnderecosLivres, setBolsaoEnderecosLivres] = useState<Endereco[]>([]);

  // Movimentações
  const [movimentacoes, setMovimentacoes] = useState<Movimentacao[]>([]);
  const [movFiltroTipo, setMovFiltroTipo] = useState('');
  const [movFiltroBusca, setMovFiltroBusca] = useState('');
  const [movFiltroDocumento, setMovFiltroDocumento] = useState('');
  const [movFiltroDataInicio, setMovFiltroDataInicio] = useState('2026-05-01');
  const [movFiltroDataFim, setMovFiltroDataFim] = useState('2026-05-31');
  const [movSelectedDocumento, setMovSelectedDocumento] = useState<string | null>(null);

  // â”€â”€â”€ Data loaders â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const loadRecebimentos = useCallback(async () => {
    setLoading(true);
    try {
      const base = recFiltroStatus
        ? `/api/wms/recebimento?status=${recFiltroStatus}&enviadoBolsao=0`
        : '/api/wms/recebimento?enviadoBolsao=0';
      const r = await fetch(base);
      if (r.ok) setRecebimentos(await r.json());
    } catch { setRecebimentos([]); } finally { setLoading(false); }
  }, [recFiltroStatus]);

  const loadEnderecos = useCallback(async () => {
    setLoading(true);
    try {
      let url = '/api/wms/enderecos?';
      if (filtroRua) url += `rua=${filtroRua}&`;
      if (filtroStatusEnd) url += `status=${filtroStatusEnd}`;
      const [rEnd, rProd] = await Promise.all([fetch(url), fetch('/api/wms/produtos')]);
      if (rEnd.ok) setEnderecos(await rEnd.json());
      if (rProd.ok) setProdutos(await rProd.json());
    } catch { setEnderecos([]); } finally { setLoading(false); }
  }, [filtroRua, filtroStatusEnd]);

  const loadDistribuicoes = useCallback(async () => {
    setLoading(true);
    try {
      const url = distFiltroStatus ? `/api/wms/distribuicao?status=${distFiltroStatus}` : '/api/wms/distribuicao';
      const r = await fetch(url);
      if (r.ok) setDistribuicoes(await r.json());
    } catch { setDistribuicoes([]); } finally { setLoading(false); }
  }, [distFiltroStatus]);

  const loadBolsao = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch('/api/wms/recebimento?status=recebido&enviadoBolsao=1');
      if (r.ok) {
        const recebidos: Recebimento[] = await r.json();
        const itens: ItemBolsao[] = [];
        for (const rec of recebidos) {
          const rd = await fetch(`/api/wms/recebimento/${rec.id}`);
          if (rd.ok) {
            const detalhe = await rd.json();
            const itensRecebimento = Array.isArray(detalhe.itens) ? detalhe.itens : [];

            if (itensRecebimento.length === 0) {
              itens.push({
                id: rec.id,
                recebimento_id: rec.id,
                numero_nf: rec.numero_nf,
                fornecedor: rec.fornecedor,
                produto_codigo: '—',
                descricao_item: 'Sem item cadastrado no recebimento',
                unidade: '—',
                quantidade_recebida: 0,
                quantidade_esperada: 0,
                status: 'pendente',
                endereco_destino: '',
                data_chegada: rec.data_chegada,
                responsavel: rec.responsavel,
              });
            } else {
              for (const item of itensRecebimento) {
                // Excluir itens já expedidos ou que passaram pelo ciclo completo (armazenado sem endereço ativo)
                const jaExpedido = item.status === 'expedido' || (!item.endereco_destino && item.endereco_armazenado);
                if (!item.endereco_destino && !jaExpedido) {
                  itens.push({
                    id: item.id,
                    recebimento_id: rec.id,
                    numero_nf: rec.numero_nf,
                    fornecedor: rec.fornecedor,
                    produto_codigo: item.produto_codigo || '—',
                    descricao_item: item.descricao_item,
                    unidade: item.unidade,
                    quantidade_recebida: item.quantidade_recebida || item.quantidade_esperada,
                    quantidade_esperada: item.quantidade_esperada,
                    status: item.status,
                    endereco_destino: item.endereco_destino || '',
                    data_chegada: rec.data_chegada,
                    responsavel: rec.responsavel,
                  });
                }
              }
            }
          }
        }
        setItensBolsao(itens);
        setBolsaoUltimaAtualizacao(new Date());
      }
    } catch { setItensBolsao([]); } finally { setLoading(false); }
  }, []);

  const loadMovimentacoes = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch('/api/wms/movimentacoes');
      if (r.ok) setMovimentacoes(await r.json());
    } catch { setMovimentacoes([]); } finally { setLoading(false); }
  }, []);

  // â”€â”€â”€ Movimentações: agrupamento por documento â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const pedidosAgrupados = useMemo(() => {
    const map = new Map<string, {
      documento: string; empresa: string; data: string;
      totalQtd: number; totalItens: number; eventos: Movimentacao[]; statusAtual: string;
    }>();
    movimentacoes.forEach(m => {
      const key = m.documento || 'SEM NF';
      if (!map.has(key)) {
        map.set(key, { documento: key, empresa: m.empresa || '—', data: m.data, totalQtd: 0, totalItens: 0, eventos: [], statusAtual: 'recebido' });
      }
      const g = map.get(key)!;
      g.eventos.push(m);
      if (m.data > g.data) g.data = m.data;
      if (Number(m.quantidade) > g.totalQtd) g.totalQtd = Number(m.quantidade);
      g.totalItens = g.eventos.filter(e => e.tipo === 'entrada').reduce((s, e) => s + Number(e.quantidade), 0) || g.totalQtd;
      if (m.tipo === 'saida' || (m.evento || '').toLowerCase().includes('expedi')) g.statusAtual = 'expedido';
      else if (m.tipo === 'armazenagem' && g.statusAtual !== 'expedido') g.statusAtual = 'armazenado';
    });
    return Array.from(map.values()).sort((a, b) => b.data.localeCompare(a.data));
  }, [movimentacoes]);

  const movFiltradosPedidos = useMemo(() => {
    return pedidosAgrupados.filter(p => {
      if (movFiltroBusca && !p.documento.toLowerCase().includes(movFiltroBusca.toLowerCase()) && !p.empresa.toLowerCase().includes(movFiltroBusca.toLowerCase())) return false;
      if (movFiltroTipo) {
        const hasEvento = p.eventos.some(e => e.tipo === movFiltroTipo || (e.evento || '').toLowerCase().includes(movFiltroTipo.toLowerCase()));
        if (!hasEvento) return false;
      }
      return true;
    });
  }, [pedidosAgrupados, movFiltroBusca, movFiltroTipo]);

  const movSelecionado = useMemo(() => {
    if (!movSelectedDocumento) return null;
    return pedidosAgrupados.find(p => p.documento === movSelectedDocumento) || null;
  }, [pedidosAgrupados, movSelectedDocumento]);

  const movEventosFiltrados = useMemo(() => {
    if (!movSelecionado) return [];
    return [...movSelecionado.eventos].sort((a, b) => {
      const da = a.dataSaida || a.dataArmazenagem || a.dataEntrada || a.data;
      const db = b.dataSaida || b.dataArmazenagem || b.dataEntrada || b.data;
      return db.localeCompare(da);
    });
  }, [movSelecionado]);

  useEffect(() => {
    if (tab === 'recebimento') loadRecebimentos();
    else if (tab === 'bolsao') loadBolsao();
    else if (tab === 'armazenagem') loadEnderecos();
    else if (tab === 'distribuicao') loadDistribuicoes();
    else if (tab === 'movimentacoes') loadMovimentacoes();
  }, [tab, loadRecebimentos, loadBolsao, loadEnderecos, loadDistribuicoes, loadMovimentacoes]);

  const ruasDisponiveis = useMemo(() => {
    const set = new Set(enderecos.map((e) => `${e.rua}-${e.bloco}`));
    return [...set].sort();
  }, [enderecos]);

  const enderecosFiltrados = useMemo(() => {
    return enderecos.filter((e) =>
      (!filtroRua || `${e.rua}-${e.bloco}` === filtroRua) &&
      (!filtroStatusEnd || e.status === filtroStatusEnd)
    );
  }, [enderecos, filtroRua, filtroStatusEnd]);

  const warehousePositions = useMemo<WarehousePosition[]>(() => {
    return enderecosFiltrados.map((e) => ({
      id: String(e.id),
      rua: `${e.rua}-${e.bloco}`,
      coluna: Number(e.posicao || 0),
      nivel: Number(e.nivel || 1),
      status: e.status,
      tipo: e.tipo,
      capacidade: Number(e.capacidade_kg || 0),
      codigoCompleto: e.codigo,
      quantidadeAtual: Number(e.quantidade || 0),
      itemDescricao: e.item_descricao ?? null,
      itemQuantidade: e.item_quantidade ?? null,
      recNumeroNf: e.rec_numero_nf ?? null,
      recFornecedor: e.rec_fornecedor ?? null,
      recDataChegada: e.rec_data_chegada ?? null,
    }));
  }, [enderecosFiltrados]);

  const handleSelectPosition = useCallback((position: WarehousePosition) => {
    setSelectedPosicaoArmazem(position);
  }, []);

  // â”€â”€â”€ Armazenagem stats â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const totalEnd = enderecos.length;
  const livresCount = useMemo(() => enderecos.filter(e => e.status === 'livre').length, [enderecos]);
  const ocupadosCount = useMemo(() => enderecos.filter(e => e.status === 'ocupado').length, [enderecos]);
  const bloqueadosCount = useMemo(() => enderecos.filter(e => e.status === 'bloqueado').length, [enderecos]);
  const occupancyPct = totalEnd > 0 ? Math.round(((ocupadosCount + bloqueadosCount) / totalEnd) * 100) : 0;

  const ruasStats = useMemo(() => {
    const byRua = new Map<string, { total: number; ocupados: number; bloqueados: number }>();
    for (const e of enderecos) {
      const key = `${e.rua}-${e.bloco}`;
      const s = byRua.get(key) || { total: 0, ocupados: 0, bloqueados: 0 };
      s.total++;
      if (e.status === 'ocupado') s.ocupados++;
      if (e.status === 'bloqueado') s.bloqueados++;
      byRua.set(key, s);
    }
    return Array.from(byRua.entries())
      .map(([rua, s]) => ({
        rua,
        total: s.total,
        ocupados: s.ocupados,
        bloqueados: s.bloqueados,
        pct: Math.round(((s.ocupados + s.bloqueados) / s.total) * 100) || 0,
      }))
      .sort((a, b) => a.rua.localeCompare(b.rua));
  }, [enderecos]);

  const ruasStatsFiltradas = useMemo(() => {
    if (!buscarRuaSidebar) return ruasStats;
    const q = buscarRuaSidebar.toLowerCase();
    return ruasStats.filter((r) => r.rua.toLowerCase().includes(q));
  }, [ruasStats, buscarRuaSidebar]);

  // â”€â”€â”€ Recebimento actions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const handleSaveRecebimento = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const itensNormalizados = recItensForm
        .map((item) => ({
          descricao_item: String(item.descricao_item || '').trim(),
          unidade: String(item.unidade || 'UN').trim() || 'UN',
          quantidade_esperada: Number(item.quantidade || 0),
          quantidade_recebida: Number(item.quantidade || 0),
          status: 'ok'
        }))
        .filter((item) => item.descricao_item && item.quantidade_esperada > 0);

      if (itensNormalizados.length === 0) {
        alert('Inclua ao menos um item com descrição e quantidade maior que zero.');
        return;
      }

      const payload = {
        ...recFormData,
        itens: itensNormalizados
      };

      const isEdicao = Boolean(editingRecId);
      const endpoint = isEdicao ? `/api/wms/recebimento/${editingRecId}` : '/api/wms/recebimento';
      const method = isEdicao ? 'PUT' : 'POST';

      const r = await fetch(endpoint, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (r.ok) {
        setEditingRecId(null);
        setShowRecModal(false);
        setRecFormData(getRecFormInitialState());
        setRecItensForm([getRecItemInitialState()]);
        loadRecebimentos();
      } else {
        const err = await r.json();
        alert(err.message || 'Erro ao salvar recebimento');
      }
    } catch { alert('Erro de conexão'); }
  };

  const handleAbrirIniciarRecebimento = async (recebimento: Recebimento) => {
    try {
      const r = await fetch(`/api/wms/recebimento/${recebimento.id}`);
      if (!r.ok) {
        alert('Não foi possível abrir o recebimento para edição.');
        return;
      }

      const detalhe = await r.json();
      const itensRecebimento: RecebimentoItemForm[] = Array.isArray(detalhe.itens) && detalhe.itens.length > 0
        ? detalhe.itens.map((item: any) => ({
            descricao_item: item.descricao_item || '',
            unidade: item.unidade || 'UN',
            quantidade: String(item.quantidade_esperada || item.quantidade_recebida || 0)
          }))
        : [getRecItemInitialState()];

      setEditingRecId(recebimento.id);
      setRecFormData({
        numero_nf: detalhe.numero_nf || '',
        fornecedor: detalhe.fornecedor || '',
        transportadora: detalhe.transportadora || '',
        motorista: detalhe.motorista || '',
        placa_veiculo: detalhe.placa_veiculo || '',
        data_chegada: detalhe.data_chegada ? String(detalhe.data_chegada).slice(0, 16) : '',
        data_prevista: detalhe.data_prevista ? String(detalhe.data_prevista).slice(0, 10) : '',
        doca: detalhe.doca || '',
        peso_total_kg: detalhe.peso_total_kg != null ? String(detalhe.peso_total_kg) : '',
        responsavel: detalhe.responsavel || '',
        observacoes: detalhe.observacoes || '',
        status: detalhe.status || 'pendente'
      });
      setRecItensForm(itensRecebimento);
      setShowRecModal(true);
    } catch {
      alert('Erro ao abrir recebimento para edição');
    }
  };

  const handleUpdateRecStatus = async (id: number, status: string) => {
    try {
      const r = await fetch(`/api/wms/recebimento/${id}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status }),
      });
      if (r.ok) { loadRecebimentos(); }
    } catch { alert('Erro ao atualizar status'); }
  };

  const handleDeleteRecebimento = async (id: number) => {
    if (!window.confirm('Deseja excluir este recebimento?')) return;
    try {
      await fetch(`/api/wms/recebimento/${id}`, { method: 'DELETE' });
      loadRecebimentos();
    } catch { alert('Erro ao excluir'); }
  };

  const handleEnviarParaBolsao = async (id: number) => {
    const confirmar = window.confirm('Deseja enviar esta NF para o Bolsão?');
    if (!confirmar) return;
    try {
      const r = await fetch(`/api/wms/recebimento/${id}/enviar-bolsao`, { method: 'POST' });
      const payload = await r.json();
      if (!r.ok) {
        alert(payload?.error || payload?.message || 'Erro ao enviar para o bolsão');
        return;
      }
      loadRecebimentos();
      alert('NF enviada para o bolsão com sucesso.');
    } catch {
      alert('Erro ao enviar para o bolsão');
    }
  };

  // â”€â”€â”€ Distribuição actions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const buscarNfParaDistribuicao = async () => {
    if (!distNfBusca.trim()) return;
    setDistNfLoading(true);
    setDistNfData(null);
    try {
      const r = await fetch(`/api/wms/recebimento/by-nf/${encodeURIComponent(distNfBusca.trim())}`);
      if (r.ok) {
        const data = await r.json();
        setDistNfData(data);
        setDistFormData(p => ({
          ...p,
          numero_pedido: data.numero_nf || distNfBusca.trim(),
          cliente: data.fornecedor || p.cliente,
          transportadora: data.transportadora || p.transportadora,
          motorista: data.motorista || p.motorista,
          placa_veiculo: data.placa_veiculo || p.placa_veiculo,
        }));
      } else {
        const err = await r.json();
        alert(err.error || 'NF não encontrada');
      }
    } catch { alert('Erro ao buscar NF'); }
    finally { setDistNfLoading(false); }
  };

  const resetDistModal = () => {
    setShowDistModal(false);
    setDistNfBusca('');
    setDistNfData(null);
    setDistFormData({ numero_pedido: '', cliente: '', destino: '', transportadora: '',
      motorista: '', placa_veiculo: '', data_programada: '',
      responsavel: '', observacoes: '', status: 'programado' });
  };

  const handleSaveDistribuicao = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const itensParaEnviar = distNfData?.itens?.map((item: any) => ({
        produto_id: item.produto_id || null,
        descricao_item: item.descricao_item || '',
        unidade: item.unidade || 'UN',
        quantidade_solicitada: item.quantidade_recebida || 0,
        endereco_origem: item.endereco_destino || null,
      })) || [];
      const r = await fetch('/api/wms/distribuicao', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...distFormData, itens: itensParaEnviar }),
      });
      if (r.ok) {
        resetDistModal();
        loadDistribuicoes();
      } else {
        const err = await r.json();
        alert(err.message || 'Erro ao salvar distribuição');
      }
    } catch { alert('Erro de conexão'); }
  };

  const handleUpdateDistStatus = async (id: number, status: string) => {
    try {
      const r = await fetch(`/api/wms/distribuicao/${id}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status }),
      });
      if (r.ok) { loadDistribuicoes(); }
    } catch { alert('Erro ao atualizar status'); }
  };

  const handleDeleteDistribuicao = async (id: number) => {
    if (!window.confirm('Deseja excluir este pedido de distribuição?')) return;
    try {
      await fetch(`/api/wms/distribuicao/${id}`, { method: 'DELETE' });
      if (selectedOnda?.id === id) { setSelectedOnda(null); setOndaItems([]); setSelectedOndaItem(null); }
      loadDistribuicoes();
    } catch { alert('Erro ao excluir'); }
  };

  const loadOndaItems = async (id: number) => {
    setLoadingOndaItems(true);
    try {
      const r = await fetch(`/api/wms/distribuicao/${id}`);
      if (r.ok) {
        const data = await r.json();
        const items: OndaItem[] = data.itens || [];
        setOndaItems(items);
        const firstPending = items.find(i => i.status === 'pendente');
        setSelectedOndaItem(firstPending || null);
      }
    } catch { }
    finally { setLoadingOndaItems(false); }
  };

  const handleSelectOnda = (onda: Distribuicao) => {
    setSelectedOnda(onda);
    setSelectedOndaItem(null);
    setOndaItems([]);
    loadOndaItems(onda.id);
  };

  const handleColetarItem = async (itemId: number, novoStatus: 'separado' | 'divergencia' | 'pendente') => {
    const item = ondaItems.find(i => i.id === itemId);
    try {
      const r = await fetch(`/api/wms/distribuicao/itens/${itemId}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          status: novoStatus,
          quantidade_separada: novoStatus === 'separado' ? (item?.quantidade_solicitada ?? 0) : 0,
        }),
      });
      if (r.ok) {
        const updated = ondaItems.map(i =>
          i.id === itemId
            ? { ...i, status: novoStatus, quantidade_separada: novoStatus === 'separado' ? i.quantidade_solicitada : 0 }
            : i
        ) as OndaItem[];
        setOndaItems(updated);
        if (novoStatus !== 'pendente') {
          const currentIdx = updated.findIndex(i => i.id === itemId);
          const nextPending =
            updated.slice(currentIdx + 1).find(i => i.status === 'pendente') ||
            updated.find(i => i.status === 'pendente');
          setSelectedOndaItem(nextPending || null);
        }
        loadDistribuicoes();
      } else {
        const err = await r.json();
        alert(err.message || 'Erro ao atualizar item');
      }
    } catch { alert('Erro ao atualizar item'); }
  };

  const handlePularItem = () => {
    if (!selectedOndaItem) return;
    const currentIdx = ondaItems.indexOf(selectedOndaItem);
    const nextPending =
      ondaItems.slice(currentIdx + 1).find(i => i.status === 'pendente') ||
      ondaItems.find(i => i.status === 'pendente' && i.id !== selectedOndaItem.id);
    if (nextPending) setSelectedOndaItem(nextPending);
  };

  const handleEnderecoBolsao = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!bolsaoItemSelecionado) return;
    if (!bolsaoEnderecoIdSelecionado) {
      alert('Selecione um endereço livre para continuar.');
      return;
    }
    try {
      const enderecoId = Number(bolsaoEnderecoIdSelecionado);
      const quantidadeDisponivel = Number(bolsaoItemSelecionado.quantidade_recebida || 0);
      const quantidadeAlocar = Number(String(bolsaoQuantidadeEnderecar).replace(',', '.'));
      const endValido = bolsaoEnderecosLivres.find((en) => en.id === enderecoId);
      if (!endValido) { alert('Endereço não encontrado ou não está livre. Verifique a aba Armazenagem.'); return; }
      if (bolsaoItemSelecionado.descricao_item === 'Sem item cadastrado no recebimento') {
        alert('Este recebimento não possui item para endereçar. Cadastre ao menos um item no recebimento.');
        return;
      }
      if (!Number.isFinite(quantidadeAlocar) || quantidadeAlocar <= 0) {
        alert('Informe uma quantidade válida para endereçar.');
        return;
      }
      if (quantidadeAlocar > quantidadeDisponivel) {
        alert(`A quantidade para endereçar não pode ser maior que o saldo disponível (${quantidadeDisponivel}).`);
        return;
      }

      const r = await fetch(`/api/wms/bolsao/itens/${bolsaoItemSelecionado.id}/enderecar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enderecoId: endValido.id, quantidade: quantidadeAlocar }),
      });

      const payload = await r.json();
      if (!r.ok) {
        alert(payload?.error || payload?.message || 'Erro ao endereçar item');
        return;
      }

      setShowBolsaoModal(false);
      setBolsaoItemSelecionado(null);
      setBolsaoEnderecoIdSelecionado('');
      setBolsaoQuantidadeEnderecar('');
      setBolsaoEnderecosLivres([]);
      loadBolsao();
      loadEnderecos();
    } catch { alert('Erro ao endereçar item'); }
  };

  const abrirModalEnderecoBolsao = async (item: ItemBolsao) => {
    try {
      const r = await fetch('/api/wms/enderecos?status=livre');
      if (!r.ok) {
        alert('Erro ao carregar endereços livres.');
        return;
      }
      const enderecosLivres: Endereco[] = await r.json();
      setBolsaoEnderecosLivres(enderecosLivres);
      setBolsaoEnderecoIdSelecionado(enderecosLivres.length > 0 ? String(enderecosLivres[0].id) : '');
      setBolsaoQuantidadeEnderecar(String(item.quantidade_recebida || 0));
      setBolsaoItemSelecionado(item);
      setShowBolsaoModal(true);
    } catch {
      alert('Erro ao carregar endereços livres.');
    }
  };

  // â”€â”€â”€ Ruas CRUD actions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const loadRuas = async () => {
    setRuasLoading(true);
    try {
      const r = await fetch('/api/wms/ruas');
      if (r.ok) setRuasList(await r.json());
    } catch { /* ignore */ } finally { setRuasLoading(false); }
  };

  const openRuasModal = () => {
    setShowRuasModal(true);
    setShowRuaForm(false);
    setRuaFormMode('create');
    setRuaFormData({ rua: '', bloco: '', num_niveis: '3', num_posicoes: '10', tipo: 'padrao', capacidade_kg: '800' });
    loadRuas();
  };

  const openEditRua = (r: RuaInfo) => {
    setRuaEditKey({ rua: r.rua, bloco: r.bloco });
    setRuaFormData({
      rua: r.rua, bloco: r.bloco,
      num_niveis: String(r.max_nivel),
      num_posicoes: String(r.max_posicao),
      tipo: r.tipo || 'padrao',
      capacidade_kg: String(r.capacidade_kg || 0)
    });
    setRuaFormMode('edit');
    setShowRuaForm(true);
  };

  const handleSaveRua = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      let res: Response;
      if (ruaFormMode === 'create') {
        res = await fetch('/api/wms/ruas', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            rua: ruaFormData.rua.toUpperCase(),
            bloco: ruaFormData.bloco,
            num_niveis: Number(ruaFormData.num_niveis),
            num_posicoes: Number(ruaFormData.num_posicoes),
            tipo: ruaFormData.tipo,
            capacidade_kg: Number(ruaFormData.capacidade_kg)
          })
        });
      } else {
        const { rua, bloco } = ruaEditKey!;
        res = await fetch(`/api/wms/ruas/${rua}/${bloco}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nova_rua: ruaFormData.rua.toUpperCase(),
            novo_bloco: ruaFormData.bloco,
            num_niveis: Number(ruaFormData.num_niveis),
            num_posicoes: Number(ruaFormData.num_posicoes),
            tipo: ruaFormData.tipo,
            capacidade_kg: Number(ruaFormData.capacidade_kg)
          })
        });
      }
      const data = await res.json();
      if (!res.ok) { alert(data.error || 'Erro ao salvar rua'); return; }
      alert(data.message);
      setShowRuaForm(false);
      loadRuas();
      loadEnderecos();
    } catch { alert('Erro de conexão'); }
  };

  const handleDeleteRua = async (rua: string, bloco: string) => {
    if (!window.confirm(`Excluir Rua ${rua}-${bloco} e todas as suas posições?\nEssa ação não pode ser desfeita.`)) return;
    try {
      const res = await fetch(`/api/wms/ruas/${rua}/${bloco}`, { method: 'DELETE' });
      const data = await res.json();
      if (!res.ok) { alert(data.error || 'Erro ao excluir rua'); return; }
      alert(data.message);
      loadRuas();
      loadEnderecos();
    } catch { alert('Erro de conexão'); }
  };

  // â”€â”€â”€ Renders â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const renderBolsao = () => {
    // â”€â”€ helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const tempoNoBolsao = (dataChegada: string) => {
      const diff = Date.now() - new Date(dataChegada).getTime();
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      if (h >= 24) return { texto: `${Math.floor(h / 24)}d ${h % 24}h ${m}m`, antigo: h >= 24 };
      return { texto: `${h}h ${m}m`, antigo: false };
    };

    const getPrioridade = (item: ItemBolsao): 'alta' | 'media' | 'baixa' => {
      if (item.prioridade) return item.prioridade;
      const h = (Date.now() - new Date(item.data_chegada).getTime()) / 3600000;
      if (h >= 24) return 'alta';
      if (h >= 8) return 'media';
      return 'baixa';
    };

    const prioConfig = {
      alta:  { label: 'Alta',  cls: 'bolsao-prio-alta' },
      media: { label: 'Média', cls: 'bolsao-prio-media' },
      baixa: { label: 'Baixa', cls: 'bolsao-prio-baixa' },
    };

    // â”€â”€ filtros â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const fornecedores = [...new Set(itensBolsao.map(i => i.fornecedor))].sort();

    const filtrado = itensBolsao.filter(i => {
      if (bolsaoFiltroBusca) {
        const q = bolsaoFiltroBusca.toLowerCase();
        if (!i.descricao_item?.toLowerCase().includes(q) &&
            !i.produto_codigo?.toLowerCase().includes(q) &&
            !i.numero_nf?.toLowerCase().includes(q) &&
            !i.fornecedor?.toLowerCase().includes(q)) return false;
      }
      if (bolsaoFiltroStatus && i.status !== bolsaoFiltroStatus) return false;
      if (bolsaoFiltroFornecedor && i.fornecedor !== bolsaoFiltroFornecedor) return false;
      if (bolsaoFiltroPrioridade && getPrioridade(i) !== bolsaoFiltroPrioridade) return false;
      return true;
    });

    // â”€â”€ paginação â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const totalPaginas = Math.max(1, Math.ceil(filtrado.length / bolsaoItensPorPagina));
    const paginaAtual = Math.min(bolsaoPagina, totalPaginas);
    const inicio = (paginaAtual - 1) * bolsaoItensPorPagina;
    const paginado = filtrado.slice(inicio, inicio + bolsaoItensPorPagina);

    // â”€â”€ stats â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const maisAntiga = itensBolsao.reduce<string | null>((min, i) =>
      !min || i.data_chegada < min ? i.data_chegada : min, null);

    const toggleSelecionado = (key: string) => {
      setBolsaoSelecionados(prev => {
        const s = new Set(prev);
        s.has(key) ? s.delete(key) : s.add(key);
        return s;
      });
    };
    const toggleTodos = () => {
      if (bolsaoSelecionados.size === paginado.length) {
        setBolsaoSelecionados(new Set());
      } else {
        setBolsaoSelecionados(new Set(paginado.map(i => `${i.recebimento_id}-${i.id}`)));
      }
    };

    return (
      <div className="wms-tab-content wms-bolsao-root">
        {/* â”€â”€ Header â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <div className="wms-bolsao-header">
          <div className="wms-bolsao-header-left">
            <h2 className="wms-bolsao-title">Bolsão</h2>
            <p className="wms-bolsao-subtitle">Cargas recebidas que aguardam endereçamento para o armazém. Após endereçar, os itens serão movidos para armazenamento.</p>
          </div>
          <div className="wms-bolsao-stats">
            <div className="wms-bolsao-stat-card">
              <span className="wms-bolsao-stat-icon" style={{background:'#e0f2fe'}}>📋</span>
              <div>
                <div className="wms-bolsao-stat-num">{itensBolsao.length}</div>
                <div className="wms-bolsao-stat-label">cargas no bolsão</div>
              </div>
              <div className="wms-bolsao-stat-title">TOTAL DE ITENS</div>
            </div>
            <div className="wms-bolsao-stat-card">
              <span className="wms-bolsao-stat-icon" style={{background:'#fce7f3'}}>📦</span>
              <div>
                <div className="wms-bolsao-stat-num">—</div>
                <div className="wms-bolsao-stat-label">volume aguardando</div>
              </div>
              <div className="wms-bolsao-stat-title">VOLUME TOTAL</div>
            </div>
            <div className="wms-bolsao-stat-card">
              <span className="wms-bolsao-stat-icon" style={{background:'#d1fae5'}}>⚖️</span>
              <div>
                <div className="wms-bolsao-stat-num">—</div>
                <div className="wms-bolsao-stat-label">peso aguardando</div>
              </div>
              <div className="wms-bolsao-stat-title">PESO TOTAL</div>
            </div>
            <div className="wms-bolsao-stat-card">
              <span className="wms-bolsao-stat-icon" style={{background:'#fef3c7'}}>🕐</span>
              <div>
                <div className="wms-bolsao-stat-num">{maisAntiga ? formatDateTime(maisAntiga) : '—'}</div>
                <div className="wms-bolsao-stat-label">tempo de permanência</div>
              </div>
              <div className="wms-bolsao-stat-title">MAIS ANTIGA</div>
            </div>
          </div>
        </div>

        {/* â”€â”€ Toolbar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <div className="wms-bolsao-toolbar">
          <div className="wms-bolsao-toolbar-left">
            <div className="wms-bolsao-search-wrap">
              <span className="wms-bolsao-search-icon">🔍</span>
              <input
                type="text"
                className="wms-bolsao-search"
                placeholder="Buscar por produto, NF, fornecedor, lote..."
                value={bolsaoFiltroBusca}
                onChange={e => { setBolsaoFiltroBusca(e.target.value); setBolsaoPagina(1); }}
              />
            </div>
            <button className={`wms-bolsao-filtros-btn${bolsaoShowFiltros ? ' active' : ''}`} onClick={() => setBolsaoShowFiltros(v => !v)}>
              ▤ Filtros
            </button>
          </div>
          <div className="wms-bolsao-toolbar-right">
            <button className="wms-bolsao-atualizar-btn" onClick={loadBolsao}>↺ Atualizar</button>
            {bolsaoUltimaAtualizacao && (
              <span className="wms-bolsao-ultima">Última atualização: {bolsaoUltimaAtualizacao.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</span>
            )}
          </div>
        </div>

        {/* â”€â”€ Filtros avançados â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        {bolsaoShowFiltros && (
          <div className="wms-bolsao-filtros-avancados">
            <div className="wms-bolsao-filtro-group">
              <label>Status</label>
              <select value={bolsaoFiltroStatus} onChange={e => { setBolsaoFiltroStatus(e.target.value); setBolsaoPagina(1); }}>
                <option value="">Todos</option>
                <option value="pendente">Pendente</option>
                <option value="ok">OK</option>
                <option value="divergencia">Divergência</option>
                <option value="avariado">Avariado</option>
              </select>
            </div>
            <div className="wms-bolsao-filtro-group">
              <label>Fornecedor</label>
              <select value={bolsaoFiltroFornecedor} onChange={e => { setBolsaoFiltroFornecedor(e.target.value); setBolsaoPagina(1); }}>
                <option value="">Todos</option>
                {fornecedores.map(f => <option key={f} value={f}>{f}</option>)}
              </select>
            </div>
            <div className="wms-bolsao-filtro-group">
              <label>Data de recebimento</label>
              <div className="wms-bolsao-daterange">
                <input type="date" placeholder="De" />
                <span>—</span>
                <input type="date" placeholder="Até" />
              </div>
            </div>
            <div className="wms-bolsao-filtro-group">
              <label>Prioridade</label>
              <select value={bolsaoFiltroPrioridade} onChange={e => { setBolsaoFiltroPrioridade(e.target.value); setBolsaoPagina(1); }}>
                <option value="">Todas</option>
                <option value="alta">Alta</option>
                <option value="media">Média</option>
                <option value="baixa">Baixa</option>
              </select>
            </div>
            <button className="wms-btn wms-btn-ghost" onClick={() => { setBolsaoFiltroStatus(''); setBolsaoFiltroFornecedor(''); setBolsaoFiltroPrioridade(''); setBolsaoFiltroBusca(''); }}>
              ✕ Limpar filtros
            </button>
          </div>
        )}

        {/* â”€â”€ Tabela â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        {loading ? <div className="wms-loading">Carregando...</div> : (
          <div className="wms-bolsao-table-wrap">
            <table className="wms-bolsao-table">
              <thead>
                <tr>
                  <th style={{width: 36}}>
                    <input type="checkbox" checked={bolsaoSelecionados.size === paginado.length && paginado.length > 0} onChange={toggleTodos} />
                  </th>
                  <th>Prioridade</th>
                  <th>Cód. Produto</th>
                  <th>Descrição</th>
                  <th>NF</th>
                  <th>Fornecedor</th>
                  <th>Qtd. Recebida</th>
                  <th>UN</th>
                  <th>Volume (m³)</th>
                  <th>Peso (kg)</th>
                  <th>Tempo no Bolsão</th>
                  <th>Status</th>
                  <th>Chegada</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {paginado.length === 0 ? (
                  <tr><td colSpan={14} className="wms-empty">Nenhum item pendente de endereçamento. 🎉</td></tr>
                ) : paginado.map(item => {
                  const key = `${item.recebimento_id}-${item.id}`;
                  const prio = getPrioridade(item);
                  const { texto: tempoTexto, antigo } = tempoNoBolsao(item.data_chegada);
                  const statusCls = item.status === 'ok' ? 'badge-green' : item.status === 'avariado' ? 'badge-red' : item.status === 'divergencia' ? 'badge-red' : 'badge-orange';
                  return (
                    <tr key={key} className={bolsaoSelecionados.has(key) ? 'wms-bolsao-row-selected' : ''}>
                      <td><input type="checkbox" checked={bolsaoSelecionados.has(key)} onChange={() => toggleSelecionado(key)} /></td>
                      <td><span className={`wms-bolsao-prio ${prioConfig[prio].cls}`}>{prioConfig[prio].label}</span></td>
                      <td><span className="wms-bolsao-sku">{item.produto_codigo || '—'}</span></td>
                      <td className="wms-bolsao-desc">{item.descricao_item}</td>
                      <td>{item.numero_nf || '—'}</td>
                      <td>{item.fornecedor}</td>
                      <td>{Number(item.quantidade_recebida).toFixed(3)}</td>
                      <td>{item.unidade || '—'}</td>
                      <td>—</td>
                      <td>—</td>
                      <td>
                        <span className={antigo ? 'wms-bolsao-tempo-antigo' : 'wms-bolsao-tempo'}>
                          {tempoTexto}
                          {antigo && <div className="wms-bolsao-tempo-label">Mais antiga</div>}
                        </span>
                      </td>
                      <td><span className={`wms-badge ${statusCls}`}>{item.status || 'pendente'}</span></td>
                      <td>{formatDateTime(item.data_chegada)}</td>
                      <td>
                        <div className="wms-bolsao-acoes-cell">
                          <button className="wms-bolsao-end-btn" onClick={() => abrirModalEnderecoBolsao(item)}>
                            📍 Endereçar
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* ── Paginação ───────────────────────────────────────────────────── */}
        <div className="wms-bolsao-pagination">
          <div className="wms-bolsao-pagination-left">
            <span>Itens por página:</span>
            <select value={bolsaoItensPorPagina} onChange={e => { setBolsaoItensPorPagina(Number(e.target.value)); setBolsaoPagina(1); }}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
            <span className="wms-bolsao-pagination-info">
              Mostrando {filtrado.length === 0 ? 0 : inicio + 1} a {Math.min(inicio + bolsaoItensPorPagina, filtrado.length)} de {filtrado.length} itens
            </span>
          </div>
          <div className="wms-bolsao-pagination-right">
            <button className="wms-bolsao-page-btn" disabled={paginaAtual === 1} onClick={() => setBolsaoPagina(p => p - 1)}>‹ Anterior</button>
            {Array.from({ length: totalPaginas }, (_, i) => i + 1).map(p => (
              <button key={p} className={`wms-bolsao-page-num${p === paginaAtual ? ' active' : ''}`} onClick={() => setBolsaoPagina(p)}>{p}</button>
            ))}
            <button className="wms-bolsao-page-btn" disabled={paginaAtual === totalPaginas} onClick={() => setBolsaoPagina(p => p + 1)}>Próxima ›</button>
          </div>
        </div>
        <div className="wms-bolsao-acoes-lote">
          <div className="wms-bolsao-acoes-lote-left">
            <button className="wms-bolsao-lote-btn wms-bolsao-lote-blue" disabled={bolsaoSelecionados.size === 0}>
              Endereçar selecionados
            </button>
            <button className="wms-bolsao-lote-btn wms-bolsao-lote-orange" disabled={bolsaoSelecionados.size === 0}>
              Alterar prioridade
            </button>
            <button className="wms-bolsao-lote-btn wms-bolsao-lote-green">
              Exportar
            </button>
            <button className="wms-bolsao-lote-btn wms-bolsao-lote-gray">
              Imprimir
            </button>
          </div>
          <div className="wms-bolsao-legenda">
            <span>Prioridade:</span>
            <span><span className="wms-bolsao-prio-dot" style={{background:'#dc2626'}}></span> Alta</span>
            <span><span className="wms-bolsao-prio-dot" style={{background:'#d97706'}}></span> Média</span>
            <span><span className="wms-bolsao-prio-dot" style={{background:'#16a34a'}}></span> Baixa</span>
          </div>
        </div>

        {/* â”€â”€ Modal endereçar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        {showBolsaoModal && bolsaoItemSelecionado && (
          <div className="wms-modal-overlay" onClick={() => { setShowBolsaoModal(false); setBolsaoEnderecoIdSelecionado(''); setBolsaoQuantidadeEnderecar(''); setBolsaoEnderecosLivres([]); }}>
            <div className="wms-modal wms-modal-sm" onClick={e => e.stopPropagation()}>
              <div className="wms-modal-header">
                <h3>Endereçar Item no Galpão</h3>
                <button className="wms-modal-close" onClick={() => { setShowBolsaoModal(false); setBolsaoEnderecoIdSelecionado(''); setBolsaoQuantidadeEnderecar(''); setBolsaoEnderecosLivres([]); }}>✕</button>
              </div>
              <form onSubmit={handleEnderecoBolsao} className="wms-modal-body">
                <div className="wms-bolsao-detail">
                  <div><span>Produto:</span> <strong>{bolsaoItemSelecionado.produto_codigo} — {bolsaoItemSelecionado.descricao_item}</strong></div>
                  <div><span>Quantidade:</span> <strong>{bolsaoItemSelecionado.quantidade_recebida} {bolsaoItemSelecionado.unidade}</strong></div>
                  <div><span>NF:</span> {bolsaoItemSelecionado.numero_nf} | <span>Fornecedor:</span> {bolsaoItemSelecionado.fornecedor}</div>
                </div>
                <div className="wms-form-group" style={{ marginTop: 16 }}>
                  <label>Quantidade para endereçar *</label>
                  <input
                    type="number"
                    step="0.001"
                    min="0.001"
                    max={Number(bolsaoItemSelecionado.quantidade_recebida || 0)}
                    required
                    value={bolsaoQuantidadeEnderecar}
                    onChange={(e) => setBolsaoQuantidadeEnderecar(e.target.value)}
                  />
                  <small style={{ color: '#94a3b8' }}>
                    Saldo disponível no bolsão: {Number(bolsaoItemSelecionado.quantidade_recebida || 0).toFixed(3)} {bolsaoItemSelecionado.unidade || 'UN'}.
                    Você pode endereçar parcialmente e manter o restante pendente.
                  </small>
                </div>
                <div className="wms-form-group" style={{ marginTop: 16 }}>
                  <label>Endereço de Destino *</label>
                  <select
                    required
                    value={bolsaoEnderecoIdSelecionado}
                    onChange={(e) => setBolsaoEnderecoIdSelecionado(e.target.value)}
                  >
                    {bolsaoEnderecosLivres.length === 0 && <option value="">Nenhum endereço livre disponível</option>}
                    {bolsaoEnderecosLivres.map((endereco) => (
                      <option key={endereco.id} value={String(endereco.id)}>
                        {endereco.codigo} - {endereco.tipo} - Cap. {endereco.capacidade_kg} kg
                      </option>
                    ))}
                  </select>
                  <small style={{ color: '#94a3b8' }}>Selecione um endereço livre da lista.</small>
                </div>
                <div className="wms-modal-footer">
                  <button type="button" className="wms-btn wms-btn-ghost" onClick={() => { setShowBolsaoModal(false); setBolsaoEnderecoIdSelecionado(''); setBolsaoQuantidadeEnderecar(''); setBolsaoEnderecosLivres([]); }}>Cancelar</button>
                  <button type="submit" className="wms-btn wms-btn-primary" disabled={bolsaoEnderecosLivres.length === 0 || !bolsaoEnderecoIdSelecionado || !bolsaoQuantidadeEnderecar}>Confirmar Endereçamento</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    );
  };
  const renderRecebimento = () => (
    <div className="wms-tab-content">
      <div className="wms-toolbar">
        <div className="wms-toolbar-filters">
          <select value={recFiltroStatus} onChange={e => setRecFiltroStatus(e.target.value)} className="wms-select">
            <option value="">Todos os status</option>
            {STATUS_REC_OPCOES.map((k) => <option key={k} value={k}>{STATUS_REC[k].label}</option>)}
          </select>
          <button className="wms-btn wms-btn-ghost" onClick={loadRecebimentos}>🔄 Atualizar</button>
        </div>
      </div>

      {loading ? <div className="wms-loading">Carregando...</div> : (
        <div className="wms-table-wrap">
          <table className="wms-table">
            <thead>
              <tr>
                <th>NF</th><th>Fornecedor</th><th>Transportadora</th>
                <th>Chegada</th><th>Doca</th><th>Itens</th>
                <th>Status</th><th>Responsável</th><th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {recebimentos.length === 0 ? (
                <tr><td colSpan={9} className="wms-empty">Nenhum recebimento encontrado.</td></tr>
              ) : recebimentos.map(r => (
                <tr key={r.id}>
                  <td><strong>{r.numero_nf || '—'}</strong></td>
                  <td>{r.fornecedor}</td>
                  <td>{r.transportadora || '—'}</td>
                  <td>{formatDateTime(r.data_chegada)}</td>
                  <td>{r.doca || '—'}</td>
                  <td>{r.total_itens ?? 0}</td>
                  <td><span className={`wms-badge ${STATUS_REC[r.status]?.cls}`}>{STATUS_REC[r.status]?.label}</span></td>
                  <td>{r.responsavel}</td>
                  <td>
                    <div className="wms-actions">
                      <button className="wms-btn-xs wms-btn-blue" onClick={() => handleAbrirIniciarRecebimento(r)}>Iniciar recebimento</button>
                      {r.status === 'conferindo' && (
                        <>
                          <button className="wms-btn-xs wms-btn-green" onClick={() => handleUpdateRecStatus(r.id, 'recebido')}>Receber</button>
                          <button className="wms-btn-xs wms-btn-orange" onClick={() => handleUpdateRecStatus(r.id, 'divergencia')}>Divergência</button>
                        </>
                      )}
                      {r.status === 'recebido' && r.enviado_bolsao !== 1 && (
                        <button className="wms-btn-xs wms-btn-teal" onClick={() => handleEnviarParaBolsao(r.id)}>Enviar Bolsão</button>
                      )}
                      {r.status === 'recebido' && r.enviado_bolsao === 1 && (
                        <span className="wms-badge badge-teal">No Bolsão</span>
                      )}
                      {(r.status === 'pendente' || r.status === 'recusado') && (
                        <button className="wms-btn-xs wms-btn-red" onClick={() => handleDeleteRecebimento(r.id)}>Excluir</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showRecModal && (
        <div className="wms-modal-overlay" onClick={() => { setShowRecModal(false); setEditingRecId(null); setRecFormData(getRecFormInitialState()); setRecItensForm([getRecItemInitialState()]); }}>
          <div className="wms-modal" onClick={e => e.stopPropagation()}>
            <div className="wms-modal-header">
              <h3>{editingRecId ? 'Iniciar recebimento' : 'Novo Recebimento'}</h3>
              <button className="wms-modal-close" onClick={() => { setShowRecModal(false); setEditingRecId(null); setRecFormData(getRecFormInitialState()); setRecItensForm([getRecItemInitialState()]); }}>✕</button>
            </div>
            <form onSubmit={handleSaveRecebimento} className="wms-modal-body">
              <div className="wms-form-grid">
                <div className="wms-form-group">
                  <label>Número da NF</label>
                  <input type="text" value={recFormData.numero_nf} onChange={e => setRecFormData(p => ({ ...p, numero_nf: e.target.value }))} placeholder="Ex: NF-001234" />
                </div>
                <div className="wms-form-group wms-form-group-wide">
                  <label>Fornecedor *</label>
                  <input type="text" required value={recFormData.fornecedor} onChange={e => setRecFormData(p => ({ ...p, fornecedor: e.target.value }))} placeholder="Nome do fornecedor" />
                </div>
                <div className="wms-form-group">
                  <label>Transportadora</label>
                  <input type="text" value={recFormData.transportadora} onChange={e => setRecFormData(p => ({ ...p, transportadora: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Motorista</label>
                  <input type="text" value={recFormData.motorista} onChange={e => setRecFormData(p => ({ ...p, motorista: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Placa do Veículo</label>
                  <input type="text" value={recFormData.placa_veiculo} onChange={e => setRecFormData(p => ({ ...p, placa_veiculo: e.target.value.toUpperCase() }))} placeholder="ABC-1234" />
                </div>
                <div className="wms-form-group">
                  <label>Doca</label>
                  <input type="text" value={recFormData.doca} onChange={e => setRecFormData(p => ({ ...p, doca: e.target.value }))} placeholder="DOCA-01" />
                </div>
                <div className="wms-form-group">
                  <label>Data de Chegada</label>
                  <input type="datetime-local" value={recFormData.data_chegada} onChange={e => setRecFormData(p => ({ ...p, data_chegada: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Data Prevista</label>
                  <input type="date" value={recFormData.data_prevista} onChange={e => setRecFormData(p => ({ ...p, data_prevista: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Peso Total (kg)</label>
                  <input type="number" step="0.01" value={recFormData.peso_total_kg} onChange={e => setRecFormData(p => ({ ...p, peso_total_kg: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Responsável *</label>
                  <input type="text" required value={recFormData.responsavel} onChange={e => setRecFormData(p => ({ ...p, responsavel: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Status</label>
                  <select value={recFormData.status} onChange={e => setRecFormData(p => ({ ...p, status: e.target.value }))}>
                    {STATUS_REC_OPCOES.map((k) => <option key={k} value={k}>{STATUS_REC[k].label}</option>)}
                  </select>
                </div>
                <div className="wms-form-group wms-form-group-full">
                  <label>Observações</label>
                  <textarea value={recFormData.observacoes} onChange={e => setRecFormData(p => ({ ...p, observacoes: e.target.value }))} rows={2} />
                </div>

                <div className="wms-form-group wms-form-group-full">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <label style={{ marginBottom: 0 }}>Itens do recebimento *</label>
                    <button
                      type="button"
                      className="wms-btn wms-btn-ghost"
                      onClick={() => setRecItensForm((prev) => [...prev, getRecItemInitialState()])}
                    >
                      + Adicionar item
                    </button>
                  </div>

                  <div style={{ display: 'grid', gap: 8 }}>
                    {recItensForm.map((item, index) => (
                      <div key={`item-${index}`} style={{ display: 'grid', gridTemplateColumns: '1fr 110px 120px auto', gap: 8, alignItems: 'end' }}>
                        <div>
                          <label>Descrição do item</label>
                          <input
                            type="text"
                            value={item.descricao_item}
                            onChange={(e) => setRecItensForm((prev) => prev.map((it, i) => i === index ? { ...it, descricao_item: e.target.value } : it))}
                            placeholder="Ex: Palete de componentes"
                            required
                          />
                        </div>
                        <div>
                          <label>Unidade</label>
                          <input
                            type="text"
                            value={item.unidade}
                            onChange={(e) => setRecItensForm((prev) => prev.map((it, i) => i === index ? { ...it, unidade: e.target.value.toUpperCase() } : it))}
                            placeholder="UN"
                          />
                        </div>
                        <div>
                          <label>Quantidade</label>
                          <input
                            type="number"
                            min="1"
                            step="1"
                            value={item.quantidade}
                            onChange={(e) => setRecItensForm((prev) => prev.map((it, i) => i === index ? { ...it, quantidade: e.target.value } : it))}
                            required
                          />
                        </div>
                        <button
                          type="button"
                          className="wms-btn wms-btn-ghost"
                          onClick={() => setRecItensForm((prev) => prev.length > 1 ? prev.filter((_, i) => i !== index) : prev)}
                          disabled={recItensForm.length === 1}
                        >
                          Remover
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="wms-modal-footer">
                <button type="button" className="wms-btn wms-btn-ghost" onClick={() => { setShowRecModal(false); setEditingRecId(null); setRecFormData(getRecFormInitialState()); setRecItensForm([getRecItemInitialState()]); }}>Cancelar</button>
                <button type="submit" className="wms-btn wms-btn-primary">{editingRecId ? 'Salvar recebimento' : 'Salvar Recebimento'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );

  const renderArmazenagem = () => {
    // Donut chart SVG helpers
    const r = 40;
    const cx = 50;
    const cy = 50;
    const circumference = 2 * Math.PI * r;
    const dashFilled = circumference * (occupancyPct / 100);

    const sel = selectedPosicaoArmazem;
    const selRuaParts = sel ? sel.rua.split('-') : [];
    const selRuaLabel = selRuaParts.length >= 2 ? `Rua ${selRuaParts.slice(0, 2).join('-')}` : sel?.rua || '';

    return (
      <div className="wms-tab-content">
        {/* â”€â”€ Top toolbar â”€â”€ */}
        <div className="wms-arm-toolbar">
          <div className="wms-arm-toolbar-left">
            <select value={filtroRua} onChange={e => { setFiltroRua(e.target.value); }} className="wms-select">
              <option value="">Todas as ruas</option>
              {ruasDisponiveis.map(r => <option key={r} value={r}>Rua {r}</option>)}
            </select>
            <select value={filtroStatusEnd} onChange={e => setFiltroStatusEnd(e.target.value)} className="wms-select">
              <option value="">Todos os status</option>
              <option value="livre">Livre</option>
              <option value="ocupado">Ocupado</option>
              <option value="bloqueado">Bloqueado</option>
            </select>
            <button className="wms-btn wms-btn-ghost" onClick={loadEnderecos}>🔄 Atualizar</button>
            <button className="wms-btn wms-btn-primary" onClick={openRuasModal}>🏗️ Gerenciar Ruas</button>
          </div>
          <div className="wms-arm-toolbar-stats">
            <span className="wms-arm-stat wms-arm-stat-livre">Livres: <strong>{livresCount}</strong></span>
            <span className="wms-arm-stat wms-arm-stat-ocupado">Ocupados: <strong>{ocupadosCount}</strong></span>
            <span className="wms-arm-stat wms-arm-stat-bloqueado">Bloqueados: <strong>{bloqueadosCount}</strong></span>
            <span className="wms-arm-stat wms-arm-stat-total">Total: <strong>{totalEnd} posições</strong></span>
          </div>
        </div>

        {loading ? <div className="wms-loading">Carregando...</div> : (
          <div className="wms-arm-layout">
            {/* â”€â”€ Left sidebar â”€â”€ */}
            <aside className="wms-arm-sidebar">
              <div className="wms-arm-sidebar-section">
                <div className="wms-arm-section-label">VISÃO GERAL</div>
                <div className="wms-arm-sidebar-title">Ocupação do Armazém</div>

                {/* Donut chart */}
                <div className="wms-arm-donut-wrap">
                  <svg viewBox="0 0 100 100" className="wms-arm-donut-svg">
                    <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e2e8f0" strokeWidth="14" />
                    <circle
                      cx={cx} cy={cy} r={r}
                      fill="none"
                      stroke="#F37216"
                      strokeWidth="14"
                      strokeDasharray={`${dashFilled} ${circumference}`}
                      strokeLinecap="round"
                      transform={`rotate(-90 ${cx} ${cy})`}
                    />
                    <text x={cx} y={cy - 4} textAnchor="middle" className="wms-arm-donut-pct">{occupancyPct}%</text>
                    <text x={cx} y={cy + 13} textAnchor="middle" className="wms-arm-donut-sub">{ocupadosCount + bloqueadosCount} / {totalEnd}</text>
                  </svg>
                </div>

                <div className="wms-arm-sidebar-legend">
                  <div className="wms-arm-leg-row">
                    <i className="wms-wh-dot wms-wh-dot-livre" />
                    <span>Livres</span>
                    <span className="wms-arm-leg-count">{livresCount}</span>
                    <span className="wms-arm-leg-pct">{totalEnd > 0 ? Math.round((livresCount / totalEnd) * 100) : 0}%</span>
                  </div>
                  <div className="wms-arm-leg-row">
                    <i className="wms-wh-dot wms-wh-dot-ocupado" />
                    <span>Ocupados</span>
                    <span className="wms-arm-leg-count">{ocupadosCount}</span>
                    <span className="wms-arm-leg-pct">{totalEnd > 0 ? Math.round((ocupadosCount / totalEnd) * 100) : 0}%</span>
                  </div>
                  <div className="wms-arm-leg-row">
                    <i className="wms-wh-dot wms-wh-dot-bloqueado" />
                    <span>Bloqueados</span>
                    <span className="wms-arm-leg-count">{bloqueadosCount}</span>
                    <span className="wms-arm-leg-pct">{totalEnd > 0 ? Math.round((bloqueadosCount / totalEnd) * 100) : 0}%</span>
                  </div>
                </div>
              </div>

              <div className="wms-arm-sidebar-section">
                <div className="wms-arm-section-label">RUAS</div>
                <input
                  type="text"
                  className="wms-arm-search-rua"
                  placeholder="Buscar rua"
                  value={buscarRuaSidebar}
                  onChange={e => setBuscarRuaSidebar(e.target.value)}
                />
                <div className="wms-arm-rua-list">
                  {ruasStatsFiltradas.map(rs => (
                    <button
                      key={rs.rua}
                      type="button"
                      className={`wms-arm-rua-item${filtroRua === rs.rua ? ' wms-arm-rua-item-active' : ''}`}
                      onClick={() => setFiltroRua(filtroRua === rs.rua ? '' : rs.rua)}
                    >
                      <span>Rua {rs.rua}</span>
                      <span className={`wms-arm-rua-pct${rs.pct >= 80 ? ' wms-arm-rua-pct-high' : rs.pct >= 50 ? ' wms-arm-rua-pct-mid' : ''}`}>{rs.pct}%</span>
                    </button>
                  ))}
                  {ruasStatsFiltradas.length === 0 && (
                    <div className="wms-arm-rua-empty">Nenhuma rua encontrada.</div>
                  )}
                </div>
                <button
                  type="button"
                  className="wms-arm-ver-mapa"
                  onClick={() => { setFiltroRua(''); setBuscarRuaSidebar(''); }}
                >
                  🗺 Ver mapa completo
                </button>
              </div>
            </aside>

            {/* â”€â”€ Center map â”€â”€ */}
            <div className="wms-arm-main">
              <div className="wms-arm-map-header">
                <div>
                  <h3 className="wms-arm-map-title">Mapa do Armazém</h3>
                  <p className="wms-arm-map-sub">Clique em uma posição para ver os detalhes</p>
                </div>
              </div>
              <WarehouseMap
                positions={warehousePositions}
                selectedPositionId={sel?.id}
                onSelectPosition={handleSelectPosition}
              />
            </div>

            {/* â”€â”€ Right details panel â”€â”€ */}
            <aside className="wms-arm-details">
              <div className="wms-arm-det-header">
                <span className="wms-arm-det-title">Detalhes da Posição</span>
                {sel && (
                  <button type="button" className="wms-arm-det-close" onClick={() => setSelectedPosicaoArmazem(null)}>✕</button>
                )}
              </div>

              {!sel ? (
                <div className="wms-arm-det-empty">
                  <div className="wms-arm-det-empty-icon">📦</div>
                  <p>Clique em uma posição no mapa para visualizar os detalhes.</p>
                </div>
              ) : (
                <div className="wms-arm-det-body">
                  <span className={`wms-arm-det-badge wms-arm-det-badge-${sel.status}`}>
                    {sel.status.charAt(0).toUpperCase() + sel.status.slice(1)}
                  </span>

                  <div className="wms-arm-det-code">{sel.codigoCompleto || sel.id}</div>
                  <div className="wms-arm-det-path">
                    {selRuaLabel} · Coluna {String(sel.coluna).padStart(2, '0')} · Nível {String(sel.nivel).padStart(2, '0')}
                  </div>

                  <div className="wms-arm-det-section">
                    <div className="wms-arm-det-section-title">Informações</div>
                    <div className="wms-arm-det-info-grid">
                      <span className="wms-arm-det-label">Status</span>
                      <span className="wms-arm-det-value">{sel.status.charAt(0).toUpperCase() + sel.status.slice(1)}</span>
                      <span className="wms-arm-det-label">Tipo de posição</span>
                      <span className="wms-arm-det-value">{sel.tipo || '—'}</span>
                      <span className="wms-arm-det-label">Capacidade máx.</span>
                      <span className="wms-arm-det-value">{sel.capacidade.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} kg</span>
                    </div>
                  </div>

                  <div className="wms-arm-det-section">
                    <div className="wms-arm-det-section-title">Carga armazenada</div>
                    {sel.status === 'ocupado' ? (
                      <div className="wms-arm-det-info-grid">
                        {sel.recNumeroNf && (
                          <>
                            <span className="wms-arm-det-label">NF</span>
                            <span className="wms-arm-det-value">{sel.recNumeroNf}</span>
                          </>
                        )}
                        {sel.recFornecedor && (
                          <>
                            <span className="wms-arm-det-label">Empresa</span>
                            <span className="wms-arm-det-value">{sel.recFornecedor}</span>
                          </>
                        )}
                        {sel.itemDescricao && (
                          <>
                            <span className="wms-arm-det-label">Descrição</span>
                            <span className="wms-arm-det-value">{sel.itemDescricao}</span>
                          </>
                        )}
                        {sel.itemQuantidade != null && (
                          <>
                            <span className="wms-arm-det-label">Quantidade</span>
                            <span className="wms-arm-det-value">{sel.itemQuantidade}</span>
                          </>
                        )}
                        {sel.recDataChegada && (
                          <>
                            <span className="wms-arm-det-label">Chegada</span>
                            <span className="wms-arm-det-value">{formatDateTime(sel.recDataChegada)}</span>
                          </>
                        )}
                        {!sel.recNumeroNf && !sel.recFornecedor && (
                          <>
                            <span className="wms-arm-det-label">Qtd armazenada</span>
                            <span className="wms-arm-det-value">{sel.quantidadeAtual}</span>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="wms-arm-det-livre-info">
                        <span>—</span>
                        <span>Posição {sel.status === 'bloqueado' ? 'bloqueada' : 'livre'}</span>
                      </div>
                    )}
                  </div>

                  <div className="wms-arm-det-section">
                    <div className="wms-arm-det-section-title">Ações rápidas</div>
                    <div className="wms-arm-det-actions">
                      <button type="button" className="wms-arm-action-btn wms-arm-action-primary">
                        📦 Movimentar para esta posição
                      </button>
                      <button
                        type="button"
                        className="wms-arm-action-btn wms-arm-action-secondary"
                        onClick={() => { /* TODO: bloquear */ }}
                      >
                        🔒 Bloquear posição
                      </button>
                      <button type="button" className="wms-arm-action-btn wms-arm-action-secondary">
                        📋 Inventariar posição
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </aside>
          </div>
        )}

        {/* â”€â”€ Gerenciar Ruas Modal â”€â”€ */}
        {showRuasModal && (
          <div className="wms-modal-overlay" onClick={() => { setShowRuasModal(false); setShowRuaForm(false); }}>
            <div className="wms-modal wms-modal-ruas" onClick={e => e.stopPropagation()}>
              <div className="wms-modal-header">
                <h3>🏗️ Gerenciar Ruas do Armazém</h3>
                <button className="wms-modal-close" onClick={() => { setShowRuasModal(false); setShowRuaForm(false); }}>✕</button>
              </div>

              <div className="wms-modal-body">
                {/* Form create/edit */}
                {showRuaForm ? (
                  <form onSubmit={handleSaveRua} className="wms-rua-form">
                    <div className="wms-rua-form-title">
                      {ruaFormMode === 'create' ? '➕ Nova Rua' : `✏️ Editar Rua ${ruaEditKey?.rua}-${ruaEditKey?.bloco}`}
                    </div>
                    <div className="wms-rua-form-grid">
                      <div className="wms-form-group">
                        <label>Letra da Rua *</label>
                        <input
                          type="text" required maxLength={3}
                          value={ruaFormData.rua}
                          onChange={e => setRuaFormData(p => ({ ...p, rua: e.target.value.toUpperCase() }))}
                          placeholder="Ex: A"
                          style={{ textTransform: 'uppercase' }}
                        />
                      </div>
                      <div className="wms-form-group">
                        <label>Bloco *</label>
                        <input
                          type="text" required maxLength={5}
                          value={ruaFormData.bloco}
                          onChange={e => setRuaFormData(p => ({ ...p, bloco: e.target.value }))}
                          placeholder="Ex: 01"
                        />
                      </div>
                      <div className="wms-form-group">
                        <label>Nº de Níveis *</label>
                        <input
                          type="number" required min={1} max={10}
                          value={ruaFormData.num_niveis}
                          onChange={e => setRuaFormData(p => ({ ...p, num_niveis: e.target.value }))}
                        />
                        {ruaFormMode === 'edit' && (
                          <small style={{ color: '#64748b' }}>Atual: {ruaEditKey && ruasList.find(r => r.rua === ruaEditKey.rua && r.bloco === ruaEditKey.bloco)?.max_nivel}</small>
                        )}
                      </div>
                      <div className="wms-form-group">
                        <label>Posições por Nível *</label>
                        <input
                          type="number" required min={1} max={50}
                          value={ruaFormData.num_posicoes}
                          onChange={e => setRuaFormData(p => ({ ...p, num_posicoes: e.target.value }))}
                        />
                        {ruaFormMode === 'edit' && (
                          <small style={{ color: '#64748b' }}>Atual: {ruaEditKey && ruasList.find(r => r.rua === ruaEditKey.rua && r.bloco === ruaEditKey.bloco)?.max_posicao}</small>
                        )}
                      </div>
                      <div className="wms-form-group">
                        <label>Tipo</label>
                        <select value={ruaFormData.tipo} onChange={e => setRuaFormData(p => ({ ...p, tipo: e.target.value }))}>
                          <option value="padrao">Padrão</option>
                          <option value="refrigerado">Refrigerado</option>
                          <option value="pesado">Pesado</option>
                          <option value="fragil">Frágil</option>
                        </select>
                      </div>
                      <div className="wms-form-group">
                        <label>Capacidade Máx. (kg)</label>
                        <input
                          type="number" min={0} step="0.01"
                          value={ruaFormData.capacidade_kg}
                          onChange={e => setRuaFormData(p => ({ ...p, capacidade_kg: e.target.value }))}
                        />
                      </div>
                    </div>
                    <div className="wms-rua-form-preview">
                      {ruaFormMode === 'create' ? (
                        <>Serão criadas <strong>{Number(ruaFormData.num_niveis || 0) * Number(ruaFormData.num_posicoes || 0)} posições</strong>{' '}({ruaFormData.num_niveis} nível(is) × {ruaFormData.num_posicoes} posição(ões))</>
                      ) : (() => {
                        const orig = ruaEditKey ? ruasList.find(r => r.rua === ruaEditKey.rua && r.bloco === ruaEditKey.bloco) : null;
                        const newTotal = Number(ruaFormData.num_niveis || 0) * Number(ruaFormData.num_posicoes || 0);
                        const diff = newTotal - (orig ? orig.total : 0);
                        return <>{diff > 0 ? `➕ ${diff} posições serão adicionadas` : diff < 0 ? `⚠️ ${Math.abs(diff)} posições livres serão removidas` : '✅ Nenhuma alteração no total de posições'} — Total final: <strong>{newTotal}</strong></>;
                      })()}
                    </div>
                    <div className="wms-modal-footer" style={{ paddingTop: 12, borderTop: '1px solid #f1f5f9' }}>
                      <button type="button" className="wms-btn wms-btn-ghost" onClick={() => setShowRuaForm(false)}>Cancelar</button>
                      <button type="submit" className="wms-btn wms-btn-primary">
                        {ruaFormMode === 'create' ? 'Criar Rua' : 'Salvar Alterações'}
                      </button>
                    </div>
                  </form>
                ) : (
                  <div className="wms-rua-list-header">
                    <button className="wms-btn wms-btn-primary" onClick={() => { setRuaFormMode('create'); setRuaFormData({ rua: '', bloco: '', num_niveis: '3', num_posicoes: '10', tipo: 'padrao', capacidade_kg: '800' }); setShowRuaForm(true); }}>
                      ➕ Nova Rua
                    </button>
                  </div>
                )}

                {/* Table of existing ruas */}
                {!showRuaForm && (
                  ruasLoading ? (
                    <div className="wms-loading">Carregando ruas...</div>
                  ) : (
                    <div className="wms-table-wrap" style={{ marginTop: 12 }}>
                      <table className="wms-table">
                        <thead>
                          <tr>
                            <th>Rua</th>
                            <th>Níveis</th>
                            <th>Posições/Nível</th>
                            <th>Total</th>
                            <th>Livres</th>
                            <th>Ocupados</th>
                            <th>Tipo</th>
                            <th>Cap. (kg)</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ruasList.length === 0 ? (
                            <tr><td colSpan={9} className="wms-empty">Nenhuma rua cadastrada.</td></tr>
                          ) : ruasList.map(r => (
                            <tr key={`${r.rua}-${r.bloco}`}>
                              <td><strong>{r.rua}-{r.bloco}</strong></td>
                              <td>{r.max_nivel}</td>
                              <td>{r.max_posicao}</td>
                              <td>{r.total}</td>
                              <td><span className="wms-badge badge-green">{r.livres}</span></td>
                              <td><span className={`wms-badge ${Number(r.ocupados) > 0 ? 'badge-orange' : 'badge-gray'}`}>{r.ocupados}</span></td>
                              <td>{r.tipo || 'padrao'}</td>
                              <td>{Number(r.capacidade_kg).toLocaleString('pt-BR', { minimumFractionDigits: 0 })}</td>
                              <td>
                                <div className="wms-actions">
                                  <button className="wms-btn-xs wms-btn-blue" onClick={() => openEditRua(r)}>✏️ Editar</button>
                                  <button className="wms-btn-xs wms-btn-red" onClick={() => handleDeleteRua(r.rua, r.bloco)}>🗑️ Excluir</button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderDistribuicao = () => {
    // Stats
    const statsPendentes = distribuicoes.filter(d => d.status === 'programado').length;
    const statsEmSep    = distribuicoes.filter(d => d.status === 'separando').length;
    const statsConcluidos = distribuicoes.filter(d => ['expedido', 'entregue'].includes(d.status)).length;
    const statsAtrasados  = distribuicoes.filter(d =>
      ['programado', 'separando'].includes(d.status) &&
      d.data_programada && new Date(d.data_programada) < new Date()
    ).length;

    // Picking map helpers
    const ruasMap = new Map<string, OndaItem[]>();
    ondaItems.forEach(item => {
      if (item.endereco_origem) {
        const rua = item.endereco_origem.split('-')[0];
        if (!ruasMap.has(rua)) ruasMap.set(rua, []);
        ruasMap.get(rua)!.push(item);
      }
    });
    const ruasOrdenadas = Array.from(ruasMap.keys()).sort();
    const todasPosicoes = Array.from(
      new Set(ondaItems.filter(i => i.endereco_origem).map(i => i.endereco_origem!.split('-')[3]))
    ).sort();

    const totalItens = ondaItems.length;
    const coletados  = ondaItems.filter(i => i.status === 'separado').length;
    const pendentes  = ondaItems.filter(i => i.status === 'pendente');
    const progresso  = totalItens > 0 ? Math.round((coletados / totalItens) * 100) : 0;

    return (
    <div className="wms-dist-layout">

      {/* â”€â”€ LEFT: onda list â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <div className="wms-dist-left">
        <div className="wms-dist-left-header">Ondas disponíveis</div>
        <div className="wms-dist-left-filters">
          <select value={distFiltroStatus} onChange={e => setDistFiltroStatus(e.target.value)}
            className="wms-select" style={{ width: '100%' }}>
            <option value="">Todos os status</option>
            {Object.entries(STATUS_DIST).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
        </div>

        <div className="wms-dist-ondas-scroll">
          {loading ? (
            <div className="wms-loading">Carregando...</div>
          ) : distribuicoes.length === 0 ? (
            <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
              Nenhuma onda encontrada.
            </div>
          ) : distribuicoes.map(d => {
            const dColet = Number(d.itens_coletados ?? 0);
            const dTotal = Number(d.total_itens ?? 0);
            const dProg  = dTotal > 0 ? Math.round((dColet / dTotal) * 100) : 0;
            const isSel  = selectedOnda?.id === d.id;
            return (
              <div key={d.id}
                className={`wms-dist-onda-card${isSel ? ' wms-dist-onda-card-active' : ''}`}
                onClick={() => handleSelectOnda(d)}>
                <div className="wms-dist-onda-card-top">
                  <span className="wms-dist-onda-id">ONDA-{String(d.id).padStart(5, '0')}</span>
                  <span className={`wms-badge ${STATUS_DIST[d.status]?.cls}`}>{STATUS_DIST[d.status]?.label}</span>
                </div>
                <div className="wms-dist-onda-card-nf">NF: {d.numero_pedido}</div>
                <div className="wms-dist-onda-card-info">
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 140 }}>{d.cliente}</span>
                  <span>{dTotal} itens</span>
                </div>
                <div className="wms-dist-onda-card-date">{formatDate(d.data_programada)}</div>
                {dTotal > 0 && (
                  <div className="wms-dist-onda-progress-row">
                    <div className="wms-dist-onda-progress-bar">
                      <div className="wms-dist-onda-progress-fill" style={{ width: `${dProg}%` }} />
                    </div>
                    <span>{dProg}%</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {selectedOnda && (
          <div className="wms-dist-resumo">
            <div className="wms-dist-resumo-title">Resumo da onda</div>
            <div className="wms-dist-resumo-ring-row">
              <div className="wms-dist-resumo-ring">
                <svg viewBox="0 0 36 36" className="wms-dist-ring-svg">
                  <circle cx="18" cy="18" r="15.9" fill="none" stroke="#e2e8f0" strokeWidth="3" />
                  <circle cx="18" cy="18" r="15.9" fill="none" stroke="#f97316" strokeWidth="3"
                    strokeDasharray={`${progresso} ${100 - progresso}`}
                    strokeDashoffset="25" strokeLinecap="round" />
                </svg>
                <div className="wms-dist-ring-label">{progresso}%</div>
              </div>
              <div className="wms-dist-resumo-stats">
                <div className="wms-dist-resumo-stat"><span>Itens totais</span><strong>{totalItens}</strong></div>
                <div className="wms-dist-resumo-stat"><span>Separados</span><strong>{coletados}</strong></div>
                <div className="wms-dist-resumo-stat"><span>Restantes</span><strong>{pendentes.length}</strong></div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* â”€â”€ CENTER: map + table â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <div className="wms-dist-center">
        {/* Stats bar */}
        <div className="wms-dist-statsbar">
          <div className="wms-dist-statsbar-title">Ondas de Separação</div>
          <div className="wms-dist-statsbar-counts">
            <div className="wms-dist-stat-chip wms-dist-stat-pend">
              <span className="chip-icon">📋</span><span className="chip-val">{statsPendentes}</span><span className="chip-lbl">Pendentes</span>
            </div>
            <div className="wms-dist-stat-chip wms-dist-stat-sep">
              <span className="chip-icon">🔄</span><span className="chip-val">{statsEmSep}</span><span className="chip-lbl">Em separação</span>
            </div>
            <div className="wms-dist-stat-chip wms-dist-stat-ok">
              <span className="chip-icon">✅</span><span className="chip-val">{statsConcluidos}</span><span className="chip-lbl">Concluídas</span>
            </div>
            {statsAtrasados > 0 && (
              <div className="wms-dist-stat-chip wms-dist-stat-atrasado">
                <span className="chip-icon">⏰</span><span className="chip-val">{statsAtrasados}</span><span className="chip-lbl">Atrasadas</span>
              </div>
            )}
          </div>
          <button className="wms-btn wms-btn-primary" onClick={() => { resetDistModal(); setShowDistModal(true); }}>
            + Iniciar nova onda
          </button>
        </div>

        {!selectedOnda ? (
          <div className="wms-dist-empty-state">
            <span>📦</span>
            <p>Selecione uma onda na lista ao lado para iniciar a separação</p>
          </div>
        ) : loadingOndaItems ? (
          <div className="wms-loading" style={{ margin: '40px auto' }}>Carregando itens da onda...</div>
        ) : (
          <div className="wms-dist-center-body">
            {/* Onda sub-header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1e293b' }}>
                  ONDA-{String(selectedOnda.id).padStart(5, '0')} — {selectedOnda.numero_pedido}
                </div>
                <div style={{ fontSize: 12, color: '#64748b' }}>{selectedOnda.cliente} → {selectedOnda.destino}</div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                {selectedOnda.status === 'programado' && (
                  <button className="wms-btn wms-btn-blue" onClick={async () => {
                    await handleUpdateDistStatus(selectedOnda.id, 'separando');
                    setSelectedOnda(p => p ? { ...p, status: 'separando' } : p);
                  }}>▶ Iniciar Separação</button>
                )}
                {selectedOnda.status === 'separando' && pendentes.length === 0 && totalItens > 0 && (
                  <button className="wms-btn wms-btn-green" onClick={async () => {
                    await handleUpdateDistStatus(selectedOnda.id, 'conferindo');
                    setSelectedOnda(p => p ? { ...p, status: 'conferindo' } : p);
                  }}>📦 Finalizar Separação</button>
                )}
                {selectedOnda.status === 'conferindo' && (
                  <button className="wms-btn wms-btn-teal" onClick={async () => {
                    await handleUpdateDistStatus(selectedOnda.id, 'expedido');
                    setSelectedOnda(p => p ? { ...p, status: 'expedido' } : p);
                  }}>🚚 Expedir</button>
                )}
                {(selectedOnda.status === 'programado' || selectedOnda.status === 'cancelado') && (
                  <button className="wms-btn wms-btn-red wms-btn-ghost" onClick={() => handleDeleteDistribuicao(selectedOnda.id)}>Excluir</button>
                )}
                <button className="wms-btn wms-btn-ghost" onClick={() => loadOndaItems(selectedOnda.id)}>🔄</button>
              </div>
            </div>

            {/* Picking Map */}
            {ruasOrdenadas.length > 0 && (
              <div className="wms-dist-mapa">
                <div className="wms-dist-mapa-header">
                  <span>🗺 Mapa de Picking — {selectedOnda.numero_pedido}</span>
                  <div className="wms-dist-mapa-legend">
                    <span className="wms-dist-leg wms-dist-leg-pend">A coletar</span>
                    <span className="wms-dist-leg wms-dist-leg-cur">Atual</span>
                    <span className="wms-dist-leg wms-dist-leg-ok">Coletado</span>
                    <span className="wms-dist-leg wms-dist-leg-div">Divergência</span>
                  </div>
                </div>
                <div className="wms-dist-mapa-body">
                  <div className="wms-dist-mapa-row wms-dist-mapa-header-row">
                    <div className="wms-dist-mapa-rua-label" />
                    {todasPosicoes.map(p => <div key={p} className="wms-dist-mapa-col-header">{p}</div>)}
                  </div>
                  {ruasOrdenadas.map(rua => (
                    <div key={rua} className="wms-dist-mapa-row">
                      <div className="wms-dist-mapa-rua-label">Rua {rua}</div>
                      {todasPosicoes.map(pos => {
                        const ruaItens = ruasMap.get(rua) || [];
                        const item = ruaItens.find(it => it.endereco_origem!.split('-')[3] === pos);
                        const isCur = item?.id === selectedOndaItem?.id;
                        let cls = 'wms-dist-cell-empty';
                        if (item) {
                          if (isCur)                        cls = 'wms-dist-cell-current';
                          else if (item.status === 'separado')  cls = 'wms-dist-cell-coletado';
                          else if (item.status === 'divergencia') cls = 'wms-dist-cell-div';
                          else                                cls = 'wms-dist-cell-pendente';
                        }
                        return (
                          <div key={pos} className={`wms-dist-cell ${cls}`}
                            onClick={() => item && setSelectedOndaItem(item)}
                            title={item ? `${item.endereco_origem}: ${item.descricao_item}` : ''}>
                            {item ? pos : ''}
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Items table */}
            <div className="wms-dist-items-section">
              <div className="wms-dist-items-header">
                <span>Itens da onda <small>(próximos a coletar)</small></span>
                <span className="wms-text-muted">{coletados} / {totalItens} coletados</span>
              </div>
              <div className="wms-table-wrap">
                <table className="wms-table wms-table-sm">
                  <thead>
                    <tr>
                      <th>#</th><th>Descrição</th><th>Endereço</th>
                      <th>Qtd. Pedido</th><th>Qtd. Coletada</th><th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ondaItems.length === 0 ? (
                      <tr><td colSpan={6} className="wms-empty">Nenhum item nesta onda.</td></tr>
                    ) : ondaItems.map((item, idx) => (
                      <tr key={item.id}
                        className={selectedOndaItem?.id === item.id ? 'wms-row-selected' : ''}
                        onClick={() => setSelectedOndaItem(item)} style={{ cursor: 'pointer' }}>
                        <td>{idx + 1}</td>
                        <td>{item.descricao_item || item.produto_descricao || '—'}</td>
                        <td>{item.endereco_origem
                          ? <strong className="wms-dist-end-code">{item.endereco_origem}</strong>
                          : <span className="wms-text-muted">—</span>}
                        </td>
                        <td>{item.quantidade_solicitada} {item.unidade}</td>
                        <td>{item.quantidade_separada} {item.unidade}</td>
                        <td>
                          {item.status === 'separado'
                            ? <span className="wms-badge badge-green">Coletado</span>
                            : item.status === 'divergencia'
                            ? <span className="wms-badge badge-red">Divergência</span>
                            : <span className="wms-badge badge-orange">A coletar</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* â”€â”€ RIGHT: collection details â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <div className="wms-dist-right">
        <div className="wms-dist-right-header">
          Detalhes da Coleta
          {selectedOndaItem && (
            <span className="wms-dist-item-counter">
              {ondaItems.indexOf(selectedOndaItem) + 1} de {totalItens}
            </span>
          )}
        </div>
        {!selectedOndaItem ? (
          <div className="wms-dist-right-empty">
            <span>👆</span>
            <p>Clique em um item no mapa ou na tabela</p>
          </div>
        ) : (
          <div className="wms-dist-right-body">
            <div className="wms-dist-det-status-row">
              {selectedOndaItem.status === 'separado'
                ? <span className="wms-badge badge-green">Coletado</span>
                : selectedOndaItem.status === 'divergencia'
                ? <span className="wms-badge badge-red">Divergência</span>
                : <span className="wms-badge badge-orange">A coletar</span>}
            </div>
            <div className="wms-dist-det-product">
              {selectedOndaItem.produto_codigo && <div className="wms-dist-det-sku">{selectedOndaItem.produto_codigo}</div>}
              <div className="wms-dist-det-name">{selectedOndaItem.descricao_item || selectedOndaItem.produto_descricao || '—'}</div>
            </div>
            <div className="wms-dist-det-section">
              <div className="wms-dist-det-section-title">Endereço</div>
              <div className="wms-dist-det-address">{selectedOndaItem.endereco_origem || '—'}</div>
            </div>
            <div className="wms-dist-det-section">
              <div className="wms-dist-det-qtd-grid">
                <div className="wms-dist-det-qtd-item">
                  <span>Qtd. Pedido</span>
                  <strong>{selectedOndaItem.quantidade_solicitada}</strong>
                </div>
                <div className="wms-dist-det-qtd-item">
                  <span>Coletada</span>
                  <strong>{selectedOndaItem.quantidade_separada}</strong>
                </div>
                <div className="wms-dist-det-qtd-item">
                  <span>A coletar</span>
                  <strong style={{ color: '#f97316' }}>
                    {Math.max(0, selectedOndaItem.quantidade_solicitada - selectedOndaItem.quantidade_separada)}
                  </strong>
                </div>
              </div>
            </div>
            {selectedOnda && (
              <div className="wms-dist-det-section">
                <div className="wms-dist-det-section-title">Informações adicionais</div>
                <div className="wms-dist-det-info-grid">
                  <span>Cliente</span><span>{selectedOnda.cliente}</span>
                  <span>NF</span><span>{selectedOnda.numero_pedido}</span>
                  <span>Destino</span><span>{selectedOnda.destino}</span>
                  {selectedOnda.data_programada && <><span>Prev. saída</span><span>{formatDate(selectedOnda.data_programada)}</span></>}
                </div>
              </div>
            )}
            {selectedOndaItem.status === 'pendente' && (
              <div className="wms-dist-det-actions">
                <button className="wms-dist-btn-confirmar" onClick={() => handleColetarItem(selectedOndaItem.id, 'separado')}>
                  ✓ Confirmar coleta
                </button>
                <button className="wms-dist-btn-pular" onClick={handlePularItem}>→ Pular item</button>
                <button className="wms-dist-btn-problema" onClick={() => handleColetarItem(selectedOndaItem.id, 'divergencia')}>
                  ⚠ Reportar problema
                </button>
              </div>
            )}
            {selectedOndaItem.status === 'separado' && (
              <div className="wms-dist-det-actions">
                <button className="wms-dist-btn-reabrir" onClick={() => handleColetarItem(selectedOndaItem.id, 'pendente')}>
                  ↩ Reabrir item
                </button>
              </div>
            )}
            {totalItens > 0 && (
              <div className="wms-dist-det-section">
                <div className="wms-dist-det-section-title">Progresso da onda</div>
                <div className="wms-dist-det-prog-bar"><div style={{ width: `${progresso}%` }} /></div>
                <div className="wms-dist-det-prog-pct">{progresso}%</div>
                <div className="wms-dist-det-info-grid">
                  <span>Itens coletados</span><span>{coletados} / {totalItens}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {showDistModal && (
        <div className="wms-modal-overlay" onClick={() => setShowDistModal(false)}>
          <div className="wms-modal" onClick={e => e.stopPropagation()}>
            <div className="wms-modal-header">
              <h3>Nova Onda de Separação</h3>
              <button className="wms-modal-close" onClick={resetDistModal}>✕</button>
            </div>
            <form onSubmit={handleSaveDistribuicao} className="wms-modal-body">
              {/* â”€â”€ Busca por NF â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
              <div className="wms-dist-nf-search">
                <label>Nota Fiscal *</label>
                <div className="wms-dist-nf-row">
                  <input
                    type="text"
                    placeholder="Digite o número da NF..."
                    value={distNfBusca}
                    onChange={e => setDistNfBusca(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), buscarNfParaDistribuicao())}
                  />
                  <button type="button" className="wms-btn wms-btn-blue" onClick={buscarNfParaDistribuicao} disabled={distNfLoading}>
                    {distNfLoading ? 'Buscando...' : '🔍 Buscar'}
                  </button>
                </div>
                {distNfData && (
                  <span className="wms-dist-nf-found">✅ NF encontrada — {distNfData.fornecedor}</span>
                )}
              </div>

              <div className="wms-form-grid">
                {/* Auto-preenchidos */}
                <div className="wms-form-group wms-form-group-wide">
                  <label>Empresa / Fornecedor *</label>
                  <input type="text" required value={distFormData.cliente}
                    onChange={e => setDistFormData(p => ({ ...p, cliente: e.target.value }))}
                    placeholder="Preenchido automaticamente via NF" />
                </div>
                <div className="wms-form-group">
                  <label>Transportadora</label>
                  <input type="text" value={distFormData.transportadora}
                    onChange={e => setDistFormData(p => ({ ...p, transportadora: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Motorista</label>
                  <input type="text" value={distFormData.motorista}
                    onChange={e => setDistFormData(p => ({ ...p, motorista: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Placa</label>
                  <input type="text" value={distFormData.placa_veiculo}
                    onChange={e => setDistFormData(p => ({ ...p, placa_veiculo: e.target.value.toUpperCase() }))} />
                </div>
                {/* Campos manuais */}
                <div className="wms-form-group wms-form-group-wide">
                  <label>Destino *</label>
                  <input type="text" required value={distFormData.destino}
                    onChange={e => setDistFormData(p => ({ ...p, destino: e.target.value }))}
                    placeholder="Cidade - UF" />
                </div>
                <div className="wms-form-group">
                  <label>Data Programada *</label>
                  <input type="date" required value={distFormData.data_programada}
                    onChange={e => setDistFormData(p => ({ ...p, data_programada: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Responsável *</label>
                  <input type="text" required value={distFormData.responsavel}
                    onChange={e => setDistFormData(p => ({ ...p, responsavel: e.target.value }))} />
                </div>
                <div className="wms-form-group">
                  <label>Status</label>
                  <select value={distFormData.status}
                    onChange={e => setDistFormData(p => ({ ...p, status: e.target.value }))}>
                    {Object.entries(STATUS_DIST).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                  </select>
                </div>
                <div className="wms-form-group wms-form-group-full">
                  <label>Observações</label>
                  <textarea value={distFormData.observacoes}
                    onChange={e => setDistFormData(p => ({ ...p, observacoes: e.target.value }))} rows={2} />
                </div>
              </div>

              {/* â”€â”€ Produtos armazenados da NF â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
              {distNfData && distNfData.itens && distNfData.itens.length > 0 && (
                <div className="wms-dist-itens-nf">
                  <div className="wms-dist-itens-title">📦 Produtos desta NF e localização no armazém</div>
                  <table className="wms-table wms-table-sm">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th>Qtd Recebida</th>
                        <th>Endereço Armazenado</th>
                        <th>Situação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {distNfData.itens.map((item: any) => (
                        <tr key={item.id}>
                          <td>{item.descricao_item}</td>
                          <td>{item.quantidade_recebida} {item.unidade}</td>
                          <td>
                            {item.endereco_destino
                              ? <strong className="wms-dist-end-code">{item.endereco_destino}</strong>
                              : <span className="wms-text-muted">—</span>}
                          </td>
                          <td>
                            {item.end_status
                              ? <span className={`wms-badge ${item.end_status === 'ocupado' ? 'badge-orange' : item.end_status === 'bloqueado' ? 'badge-red' : 'badge-green'}`}>{item.end_status}</span>
                              : <span className="wms-text-muted">não endereçado</span>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="wms-modal-footer">
                <button type="button" className="wms-btn wms-btn-ghost" onClick={resetDistModal}>Cancelar</button>
                <button type="submit" className="wms-btn wms-btn-primary">Salvar Distribuição</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
    );
  };

  const renderMovimentacoes = () => {
    const eventoConfig: Record<string, { label: string; icon: string; color: string }> = {
      entrada:     { label: 'Recebimento',          icon: '↓', color: '#16a34a' },
      armazenagem: { label: 'Armazenagem',           icon: '📦', color: '#d97706' },
      saida:       { label: 'Expedição',             icon: '🚛', color: '#dc2626' },
      movimentacao:{ label: 'Movimentação interna',  icon: '⇄',  color: '#2563eb' },
    };

    const statusMovConfig: Record<string, { label: string; cls: string }> = {
      expedido:   { label: 'Expedido',   cls: 'mov-status-expedido' },
      armazenado: { label: 'Armazenado', cls: 'mov-status-armazenado' },
      recebido:   { label: 'Recebido',   cls: 'mov-status-recebido' },
    };

    const getEventoConfig = (m: Movimentacao) => {
      const t = m.tipo || '';
      return eventoConfig[t] || { label: m.evento || m.tipo || '—', icon: '•', color: '#64748b' };
    };

    const getEventoData = (m: Movimentacao) =>
      m.dataSaida || m.dataArmazenagem || m.dataEntrada || m.data;

    const getLocalizacao = (m: Movimentacao) => {
      if (m.tipo === 'saida') return m.destino || m.origem || '—';
      if (m.tipo === 'armazenagem') return m.endereco || m.destino || '—';
      return m.origem || '—';
    };

    const getResponsavel = (m: Movimentacao) =>
      [m.expedidoPor, m.entreguePor, m.responsavel].filter(Boolean).join(' / ') || '—';

    const qtdExpedida = movSelecionado
      ? movSelecionado.eventos.filter(e => e.tipo === 'saida').reduce((s, e) => s + Number(e.quantidade), 0)
      : 0;
    const qtdTotal = Number(movSelecionado?.totalQtd) || 0;
    const pctExpedida = qtdTotal > 0 ? Math.round((qtdExpedida / qtdTotal) * 100) : 0;

    return (
      <div className="wms-tab-content wms-mov-root">
        {/* â”€â”€ Top filter bar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <div className="wms-mov-filters">
          <div className="wms-mov-filter-group">
            <label>Período</label>
            <div className="wms-mov-daterange">
              <input type="date" value={movFiltroDataInicio} onChange={e => setMovFiltroDataInicio(e.target.value)} />
              <span>até</span>
              <input type="date" value={movFiltroDataFim} onChange={e => setMovFiltroDataFim(e.target.value)} />
              <span className="wms-mov-filter-icon">📅</span>
            </div>
          </div>
          <div className="wms-mov-filter-group">
            <label>Tipo de evento</label>
            <select value={movFiltroTipo} onChange={e => setMovFiltroTipo(e.target.value)} className="wms-mov-select">
              <option value="">Todos</option>
              <option value="entrada">Recebimento</option>
              <option value="armazenagem">Armazenagem</option>
              <option value="saida">Expedição</option>
              <option value="movimentacao">Movimentação interna</option>
            </select>
          </div>
          <div className="wms-mov-filter-group">
            <label>SKU / Produto</label>
            <select className="wms-mov-select">
              <option value="">Todos</option>
            </select>
          </div>
          <div className="wms-mov-filter-group">
            <label>Documento</label>
            <div className="wms-mov-doc-input">
              <input
                type="text"
                placeholder="Digite o nº do documento"
                value={movFiltroDocumento}
                onChange={e => setMovFiltroDocumento(e.target.value)}
              />
              <span className="wms-mov-filter-icon">▾</span>
            </div>
          </div>
          <button className="wms-btn wms-btn-ghost wms-mov-mais-filtros" onClick={loadMovimentacoes}>
            ▤ Mais filtros
          </button>
        </div>

        {/* â”€â”€ 3-panel body â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <div className="wms-mov-layout">
          {/* â”€â”€ Left: Entidades â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
          <div className="wms-mov-sidebar">
            <div className="wms-mov-sidebar-header">
              <span className="wms-mov-sidebar-title">Entidades</span>
            </div>
            <div className="wms-mov-entity-tabs">
              <button className="wms-mov-entity-tab active">Pedidos</button>
              <button className="wms-mov-entity-tab">Lotes</button>
              <button className="wms-mov-entity-tab">Pallets</button>
              <button className="wms-mov-entity-tab">NF-e</button>
            </div>
            <div className="wms-mov-search-box">
              <input
                type="text"
                placeholder="Buscar pedido..."
                value={movFiltroBusca}
                onChange={e => setMovFiltroBusca(e.target.value)}
              />
              <span className="wms-mov-search-icon">🔍</span>
            </div>
            <div className="wms-mov-entity-list">
              {loading && <div className="wms-loading">Carregando...</div>}
              {!loading && movFiltradosPedidos.length === 0 && (
                <div className="wms-empty-small">Nenhum pedido encontrado.</div>
              )}
              {movFiltradosPedidos.map(p => {
                const sc = statusMovConfig[p.statusAtual] || { label: p.statusAtual, cls: 'mov-status-recebido' };
                const isActive = movSelectedDocumento === p.documento;
                return (
                  <div
                    key={p.documento}
                    className={`wms-mov-entity-card${isActive ? ' active' : ''}`}
                    onClick={() => setMovSelectedDocumento(p.documento)}
                  >
                    <div className="wms-mov-entity-card-top">
                      <span className="wms-mov-entity-num">{p.documento}</span>
                      <span className={`wms-mov-status-badge ${sc.cls}`}>{sc.label}</span>
                    </div>
                    <div className="wms-mov-entity-empresa">{p.empresa}</div>
                    <div className="wms-mov-entity-meta">
                      <span>{formatDateTime(p.data)}</span>
                      <span>{p.totalQtd} itens</span>
                    </div>
                  </div>
                );
              })}
            </div>
            <button className="wms-mov-ver-todos" onClick={loadMovimentacoes}>
              Ver todos os pedidos →
            </button>
          </div>

          {/* â”€â”€ Center: timeline â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
          <div className="wms-mov-center">
            {!movSelecionado ? (
              <div className="wms-mov-empty-center">
                <div className="wms-mov-empty-icon">📋</div>
                <p>Selecione um pedido na lista para ver o histórico de movimentações.</p>
              </div>
            ) : (
              <>
                {/* Header */}
                <div className="wms-mov-detail-header">
                  <div className="wms-mov-detail-title">
                    <span>Pedido {movSelecionado.documento}</span>
                    <span className={`wms-mov-status-badge ${(statusMovConfig[movSelecionado.statusAtual] || {cls:'mov-status-recebido'}).cls}`}>
                      {(statusMovConfig[movSelecionado.statusAtual] || {label: movSelecionado.statusAtual}).label}
                    </span>
                  </div>
                  <div className="wms-mov-detail-meta">
                    <span>👤 Cliente: {movSelecionado.empresa}</span>
                    <span>📅 Data do pedido: {movEventosFiltrados[movEventosFiltrados.length - 1] ? formatDateTime(getEventoData(movEventosFiltrados[movEventosFiltrados.length - 1])) : '—'}</span>
                    <span>📦 Itens: {movSelecionado.totalQtd}</span>
                  </div>
                </div>

                {/* Product table */}
                <div className="wms-mov-product-table-wrap">
                  <table className="wms-mov-product-table">
                    <thead>
                      <tr>
                        <th>Produto</th>
                        <th>SKU</th>
                        <th>Quantidade total</th>
                        <th>Unidade</th>
                        <th>Lote</th>
                        <th>Valor total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {movSelecionado.eventos
                        .filter(e => e.tipo === 'entrada')
                        .map((e, i) => (
                          <tr key={i}>
                            <td>{e.produtoDescricao || 'Item sem cadastro'}</td>
                            <td>{e.produtoCodigo || '—'}</td>
                            <td>{e.quantidade}</td>
                            <td>UN</td>
                            <td>—</td>
                            <td>—</td>
                          </tr>
                        ))
                      }
                      {movSelecionado.eventos.filter(e => e.tipo === 'entrada').length === 0 && (
                        <tr>
                          <td>{movSelecionado.eventos[0]?.produtoDescricao || '—'}</td>
                          <td>{movSelecionado.eventos[0]?.produtoCodigo || '—'}</td>
                          <td>{movSelecionado.totalQtd}</td>
                          <td>UN</td>
                          <td>—</td>
                          <td>—</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Events timeline */}
                <div className="wms-mov-timeline-wrap">
                  <table className="wms-mov-timeline-table">
                    <thead>
                      <tr>
                        <th>Evento</th>
                        <th>Data / Hora</th>
                        <th>Localização</th>
                        <th>Responsável</th>
                        <th>Documento</th>
                        <th>Observação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {movEventosFiltrados.map((m, i) => {
                        const cfg = getEventoConfig(m);
                        const dt = getEventoData(m);
                        return (
                          <tr key={`${m.id}-${i}`} className="wms-mov-timeline-row">
                            <td>
                              <div className="wms-mov-evento-cell">
                                <span className="wms-mov-event-icon" style={{ background: cfg.color }}>
                                  {cfg.icon}
                                </span>
                                <div>
                                  <div className="wms-mov-event-name">{cfg.label}</div>
                                  <div className="wms-mov-event-sub">
                                    {m.tipo === 'saida' ? 'Saída do armazém para entrega'
                                      : m.tipo === 'armazenagem' ? 'Produto armazenado'
                                      : m.tipo === 'movimentacao' ? 'Transferência entre posições'
                                      : 'Entrada de mercadoria'}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div>{dt ? new Date(dt).toLocaleDateString('pt-BR') : '—'}</div>
                              <div className="wms-sub-text">{dt ? new Date(dt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : ''}</div>
                            </td>
                            <td>
                              <div>{getLocalizacao(m)}</div>
                              {m.tipo === 'armazenagem' && m.endereco && (
                                <div className="wms-sub-text">{m.endereco}</div>
                              )}
                            </td>
                            <td>{getResponsavel(m)}</td>
                            <td>
                              {m.documento ? (
                                <div>
                                  <div>NF-e {m.documento}</div>
                                  <button className="wms-mov-link-btn">Ver documento</button>
                                </div>
                              ) : '—'}
                            </td>
                            <td>{m.observacoes || '—'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <button className="wms-mov-detalhes-btn">
                  Mostrar detalhes técnicos ▾
                </button>
              </>
            )}
          </div>

          {/* â”€â”€ Right: Detalhes da entidade â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
          <div className="wms-mov-details-panel">
            {!movSelecionado ? (
              <div className="wms-mov-empty-right">Selecione um pedido</div>
            ) : (
              <>
                <div className="wms-mov-details-section-title">Detalhes da entidade</div>
                <div className="wms-mov-details-grid">
                  <span className="wms-mov-detail-key">Pedido</span>
                  <span className="wms-mov-detail-val">{movSelecionado.documento}</span>
                  <span className="wms-mov-detail-key">Cliente</span>
                  <span className="wms-mov-detail-val">{movSelecionado.empresa}</span>
                  <span className="wms-mov-detail-key">Data do pedido</span>
                  <span className="wms-mov-detail-val">
                    {movEventosFiltrados.length > 0 ? formatDateTime(getEventoData(movEventosFiltrados[movEventosFiltrados.length - 1])) : '—'}
                  </span>
                  <span className="wms-mov-detail-key">Status atual</span>
                  <span className="wms-mov-detail-val">
                    <span className={`wms-mov-status-badge ${(statusMovConfig[movSelecionado.statusAtual] || {cls:'mov-status-recebido'}).cls}`}>
                      {(statusMovConfig[movSelecionado.statusAtual] || {label: movSelecionado.statusAtual}).label}
                    </span>
                  </span>
                  <span className="wms-mov-detail-key">Prioridade</span>
                  <span className="wms-mov-detail-val">Normal</span>
                </div>

                <div className="wms-mov-details-section-title" style={{marginTop: '16px'}}>Resumo</div>
                <div className="wms-mov-details-grid">
                  <span className="wms-mov-detail-key">Itens do pedido</span>
                  <span className="wms-mov-detail-val">{Number(movSelecionado.totalQtd)}</span>
                  <span className="wms-mov-detail-key">Quantidade total</span>
                  <span className="wms-mov-detail-val">{Number(movSelecionado.totalQtd).toFixed(2)}</span>
                  <span className="wms-mov-detail-key">Qtd. expedida</span>
                  <span className="wms-mov-detail-val">{Number(qtdExpedida).toFixed(2)} ({pctExpedida}%)</span>
                  <span className="wms-mov-detail-key">Qtd. pendente</span>
                  <span className="wms-mov-detail-val">{(Number(qtdTotal) - Number(qtdExpedida)).toFixed(2)} ({100 - pctExpedida}%)</span>
                </div>

                <div className="wms-mov-details-section-title" style={{marginTop: '16px'}}>Ações rápidas</div>
                <div className="wms-mov-acoes">
                  <button className="wms-mov-acao-btn">👁 Ver pedido</button>
                  <button className="wms-mov-acao-btn">🖨 Imprimir histórico</button>
                  <button className="wms-mov-acao-btn">⬇ Exportar</button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  // â”€â”€â”€ Main render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  return (
    <div className="wms-module">
      <div className="wms-header">
        <div className="wms-header-left">
          <span className="wms-header-icon">🏭</span>
          <div>
            <h1 className="wms-header-title">WMS — Warehouse Management</h1>
            <p className="wms-header-sub">Recebimento · Armazenagem · Distribuição</p>
          </div>
        </div>
        <button className="wms-btn wms-btn-ghost wms-btn-refresh" onClick={() => { if (tab === 'recebimento') loadRecebimentos(); else if (tab === 'bolsao') loadBolsao(); else if (tab === 'armazenagem') loadEnderecos(); else if (tab === 'distribuicao') loadDistribuicoes(); else loadMovimentacoes(); }}>🔄</button>
      </div>

      <div className="wms-tabs">
        {([
          ['recebimento',  '📥', 'Recebimento'],
          ['bolsao',       '📋', 'Bolsão'],
          ['armazenagem',  '🏭', 'Armazenagem'],
          ['distribuicao', '🚛', 'Distribuição'],
          ['movimentacoes','🔄', 'Movimentações'],
        ] as [Tab, string, string][]).map(([id, icon, label]) => (
          <button
            key={id}
            className={`wms-tab-btn${tab === id ? ' active' : ''}`}
            onClick={() => setTab(id)}
          >
            {icon} {label}
          </button>
        ))}
      </div>

      <div className="wms-tab-body">
        {tab === 'recebimento'  && renderRecebimento()}
        {tab === 'bolsao'       && renderBolsao()}
        {tab === 'armazenagem'  && renderArmazenagem()}
        {tab === 'distribuicao' && renderDistribuicao()}
        {tab === 'movimentacoes'&& renderMovimentacoes()}
      </div>
    </div>
  );
};

export default WMSModule;
